<section class="app-print-section" *ngIf="!isLoading" style="padding: 1rem;">

  <div id="estimate-form">
    <header style="display: flex">
      <section *ngIf="visibility.ShowCompanySection">
        <img *ngIf="visibility.ShowCompanyLogo && companyLogo"
          [src]="concatFilePath | memoizedFn: companyLogo?.UriPath :companyLogo?.FileName"
          class="company-logo {{ logoSizeClass }}" height="90" width="120" />
        <div *ngIf="visibility.ShowCompanyName">
          <h1>{{ estimate?.CompanyName }}</h1>
        </div>
        <div class="f-row" *ngIf="visibility.ShowLicenseNumber && estimate?.LicenseNumber">
          <span style="overflow-wrap: anywhere">{{ estimate?.LicenseNumberName | licenseLabel }}</span>
          <span>:</span>
          <span style="padding-left: 4px; overflow-wrap: anywhere">{{
            estimate?.LicenseNumber
            }}</span>
        </div>
        <div>
          <div *ngIf="visibility.ShowCompanyAddress && !isEmpty(estimate.CompanyAddress)"
            [innerHTML]="estimate.CompanyAddress | addressFormat"></div>
        </div>
        <br>
        <div>
          <div *ngIf="visibility.ShowCompanyPhone">
            {{
            formatNumberForPreivew(estimate?.CompanyPhoneNo?.number || estimate?.CompanyPhoneNo || "") }}
          </div>
          <div *ngIf="visibility.ShowCompanyEmail" [innerHTML]="estimate.CompanyEmail | softBreak"></div>
          <div *ngIf="visibility.ShowCompanyWebsite" [innerHTML]="estimate.CompanyWebsite | softBreak"></div>
        </div>
      </section>
      <section class="t-right">
        <div *ngIf="visibility.ShowDocumentTitle">
          <h1 *ngIf="estimateDetails?.Name == 'Change Order'; else notChangeOrder">
            {{ estimateDetails?.Name == "Change Order" ? (estimateDetails?.Title || 'Change Order') :
            (estimateDetails?.Title || estimate?.EstimateAlias) }}
          </h1>
          <ng-template #notChangeOrder>
            <h1>{{estimateDetails?.Title || estimate?.Name || estimate?.EstimateAlias}}</h1>
          </ng-template>
        </div>
        <div *ngIf="visibility.ShowDocumentNumber">
          <strong>
            <span>
              {{ estimateDetails?.Name == "Change Order" ? estimateDetails?.Name : estimate?.EstimateAlias }}
              Number:
            </span>
            <span style="
              min-width: 100px;
              max-width: 100%;
              display: inline-block;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              vertical-align: bottom;
            ">{{ estimateDetails?.EstimateNumber }}</span>
          </strong>
        </div>
        <div *ngIf="visibility.ShowDocumentDate && !estimate?.IsTemplate">
          <small>
            {{ estimateDetails?.Name == "Change Order" ? estimateDetails?.Name : estimate?.EstimateAlias }}
            Date:
          </small>
          <span class="d-inline-block" id="portal-start-date" style="min-width: 100px; display: inline-block">
            {{ estimateDetails?.EstimateDate | date: 'mediumDate' }}
          </span>
        </div>
        <div *ngIf="visibility.ShowExpiryDate && expiryDisplay as expiry">
          <small>
            {{ expiry.label }}
          </small>
          <span class="d-inline-block" id="portal-end-date" style="min-width: 100px; display: inline-block">
            {{ expiry.date | date : "mediumDate" }}
          </span>
        </div>
        <ng-container *ngIf="visibility.ShowCustomFields && estimateDetails?.CustomFieldsData?.length">
          <ng-container *ngFor="let cf of estimateDetails.CustomFieldsData">
            <div *ngIf="cf.Value">
              <small>{{ cf.Name }}</small>
              <span class="d-inline-block" style="min-width: 100px; display: inline-block">{{ cf.Value }}</span>
            </div>
          </ng-container>
        </ng-container>
        <br />
        <ng-container *ngIf="visibility.ShowClientSection">
          <div *ngIf="estimate?.CustomerId">
            <h2>Client</h2>
          </div>

          <div *ngIf="visibility.ShowClientName">
            <strong>
              {{
              (estimate?.CustomerId) ?
              (estimate | displayCompanyAndUserNameEstInvPipe) :
              (

              (estimate?.CustomerFirstName || customerPlaceHolderData?.CustomerFirstName || "") + " " +
              (estimate?.CustomerLastName || customerPlaceHolderData?.CustomerLastName || "") + " " +
              (customerPlaceHolderData?.CompanyName ? "(" + customerPlaceHolderData?.CompanyName + ")" : "")
              )
              }}
            </strong>
          </div>
          <div *ngIf="visibility.ShowClientAddress && !isEmpty(estimate.CustomerAddress)">
            <div [innerHTML]="estimate.CustomerAddress | addressFormat : customerPlaceHolderData?.CustomerAddress">
            </div>
          </div>
          <div *ngIf="visibility.ShowClientPhone">
            {{ formatNumberForPreivew(estimate?.CustomerPhone || customerPlaceHolderData?.CustomerPhone || "") }}
          </div>
          <div *ngIf="visibility.ShowClientEmail"
            [innerHTML]="(estimate?.CustomerEmail || customerPlaceHolderData?.CompanyEmail || '') | softBreak">
          </div>
        </ng-container>
        <br />

        <ng-container *ngIf="estimate?.ShowBillingAddressToCustomer && hasPrintableAddress(estimate?.CustomerBillingAddress)">
          <div>
            <strong>Billing Address</strong>
          </div>
          <div [innerHTML]="estimate.CustomerBillingAddress | addressFormat"></div>
        </ng-container>
        <br />
        <div *ngIf="estimate?.ShowProjectInfoToCustomer && estimate?.ProjectId">
          <h2>Project</h2>
          <div>
            <div>
              <strong>
                <span *ngIf="showProjectNumberText">{{ projectNumberText }}</span>
                <span *ngIf="showProjectNumberText && showProjectNameText"> - </span>
                <span *ngIf="showProjectNameText">{{ projectNameText }}</span>
              </strong>
            </div>
            <div *ngIf="visibility.ShowProjectAddress && !isEmpty(estimate.ProjectAddress)"
              [innerHTML]="estimate.ProjectAddress | addressFormat : projectPlaceHolderData?.ProjectAddress"></div>
            <div *ngIf="visibility.ShowProjectPhone && projectPlaceHolderData?.PhoneNo">
              {{ projectPlaceHolderData?.PhoneNo || "" }}
            </div>
          </div>
        </div>
      </section>
    </header>

    <ng-template #customerViewEstimate>
      <div class="message">
        <i class="i-file-invoice big-display"></i>
        <div class="font-22 t-center mb-2">
          <span class="danger">{{
            estimateDetails?.Name == "Change Order"
            ? estimateDetails?.Name
            : estimate?.EstimateAlias
            }}
            {{ estimateDetails?.EstimateNumber }} has expired.</span>
        </div>
        <div class="font-22 t-center">Please contact {{ estimate?.CompanyName }} for assistance.</div>
      </div>
    </ng-template>

    <ng-container
      *ngIf="((estimateDetails?.CustomerCanView && estimate?.IsPublished) || (estimate?.IsPublished && isPreview)); else customerViewEstimate">
      <!-- Introduction, and the estimate-scope variables it hangs off; those still print when the
           introduction itself is hidden. -->
      <section *ngIf="visibility.ShowIntroduction || estimateDetails?.ClientVisibleVariables?.length">
        <div class="introduction">
          <div *ngIf="visibility.ShowIntroduction" class="intro-text description-inner innerHtmlCkEditorContent">
            <p [innerHtml]="estimateDetails?.EstimateIntroduction | sanitize"></p>
          </div>
          <ng-container [ngTemplateOutlet]="clientVariableLine"
            [ngTemplateOutletContext]="{ vars: estimateDetails?.ClientVisibleVariables }"></ng-container>
        </div>
      </section>

      <section class="estimate-section-grid hide-print clear-fix">
        <div class="cstm-grid-header">
          <div class="cstm-grid-header-row">
            <div class="grid-column"><span>Description</span></div>
            <ng-container *ngIf="estimate?.IsItemized">
              <div class="grid-column quantity-col" *ngIf="isAllQuantityViewAble"><span>QTY</span></div>
              <div class="grid-column cost-col" *ngIf="isAllQuantityViewAble"><span>Rate</span></div>
            </ng-container>
            <div class="grid-column price-col"><span>Price</span></div>
          </div>
        </div>
        <ng-container *ngIf="estimateDetails.EstimateDetailsSections?.length || removedSections?.length">
          <!-- Removed sections -->

          <ng-container *ngIf="removedSections?.length">
            <div class="grid-labels"></div>
          </ng-container>

          <ng-container *ngFor="let item of removedSections">
            <div class="cstm-grid-body removed-section">
              <div class="cstm-grid-body-row item-selectable">
                <div class="cstm-grid-body-row-content">
                  <div class="grid-row-content-right">
                    <div class="grid-row-content-right-inner">
                      <div class="grid-column grid-items-description f-column">
                        <div class="grid-items-description-inner">
                          <div class="grid-items-description__left">
                            <h5 class="text-break" style="font-size: 14px;">{{ item.Name || "Product or Service" }}</h5>
                            Removed from previous
                            <strong>{{
                              item.ModifiedFromSectionDetailsType ===
                              estimateDetailTypeEnum.Normal
                              ? "Estimate"
                              : "Change Order"
                              }}
                              :
                            </strong>
                            <strong style="
                                width: fit-content;
                                max-width: 60vw;
                                display: inline-block;
                                vertical-align: top;
                              ">{{ item.ModifiedFromSectionDetailsNumber }}</strong>
                          </div>
                        </div>
                      </div>
                      <div class="grid-column price-col font-roboto">
                        <span>{{ item.Total || 0 | formatNumber }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Selection enabled sections -->
          <ng-container *ngFor="let item of estimateDetails.EstimateDetailsSections, let sectionIndex = index">
            <ng-container *ngIf="(item.IsSelectionEnabled || estimate.IsItemized) && !item.IsDisplayOnly">

              <div class="grid-labels">
                <h4 class="text-break">{{ item.Name || "Product or Service" }}</h4>
                <ng-container [ngTemplateOutlet]="clientVariableLine"
                  [ngTemplateOutletContext]="{ vars: item.ClientVisibleVariables }"></ng-container>
                <span class="label-title"
                  *ngIf="item.IsSelectionEnabled && (item.displayList || []).length > 0 && !selectionsLocked">
                  {{(item.SelectionType ==
                  estimateSelectionType.OptionalMultipleSelection ?
                  'Please select any options' : 'Please select one option')}}</span>
              </div>

              <div
                class="cstm-grid-body {{item.IsSelectionEnabled && item.SelectionType == estimateSelectionType.OptionalMultipleSelection ? 'checkbox-grid' : ''}}">
                <ng-container
                  *ngIf="item.IsSelectionEnabled && item.SelectionType == estimateSelectionType.OptionalMultipleSelection && (item.displayList || []).length > 0 && !selectionsLocked">
                  <div class="cstm-grid-body-row item-selectable custom_checkbox select-all-checkbox-btn">
                    <input (change)="toggleSelectAll($event, sectionIndex)" [(ngModel)]="item.SelectionAllSelect"
                      type="checkbox" id="checkbox-item-all-{{item.Id}}">
                    <div class="cstm-grid-body-row-content">
                      <div class="grid-row-content-left bg-transparent">
                        <label for="checkbox-item-all-{{item.Id}}"
                          class=" selectable-item {{item.SelectionSomeSelect && !item.SelectionAllSelect?'someSelect':''}}"></label>
                      </div>
                      <div class="grid-row-content-right">
                        <div class="grid-row-content-right-inner h-100 align-items-center">
                          <div class="grid-column grid-items-description">
                            <div class="grid-items-description-inner">
                              <div class="grid-items-description__left">
                                <h5 class="mb-1"><strong>Select all</strong></h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="item.IsSelectionEnabled && item.SelectionType == estimateSelectionType.OptionalSingleSelection && (item.displayList || []).length > 0 && (item.NoneSelected || status != estimateStatusTypes.Approved)">
                  <div class="cstm-grid-body-row item-selectable custom_radio select-none-radio-btn">
                    <input (change)="noneSelected(sectionIndex)" [checked]="item.NoneSelected?true:null" type="radio"
                      id="radio-grid-btn-{{item.Id}}" name="radio-grid-btn-{{item.Id}}"
                      [disabled]="selectionsLocked">
                    <div class="cstm-grid-body-row-content">
                      <div class="grid-row-content-left">
                        <label for="radio-grid-btn-{{item.Id}}" class="selectable-item"></label>
                      </div>
                      <div class="grid-row-content-right">
                        <div class="grid-row-content-right-inner">
                          <div class="grid-column grid-items-description">
                            <div class="grid-items-description-inner">
                              <div class="grid-items-description__left">
                                <h5 class="mb-1 mt-1" style="padding-top:0.15rem !important"><strong>None</strong></h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <ng-container
                  *ngFor="let costlineOrSubsection of item.displayList, let displayIndex = index ; let last = last">
                  <ng-container *ngIf="costlineOrSubsection.renderedType === renderTypes.costline">
                    <ng-template
                      [ngTemplateOutletContext]="{section:item, costline: costlineOrSubsection, IsSelectionEnabled: item.IsSelectionEnabled, sectionId: item.Id, sectionIndex: sectionIndex, displayIndex: displayIndex, selectionType: item.SelectionType}"
                      [ngTemplateOutlet]="sectionTemplate">
                    </ng-template>
                  </ng-container>

                  <ng-container *ngIf="costlineOrSubsection.renderedType === renderTypes.subsection">
                    <ng-template
                      [ngTemplateOutletContext]="{section:item, costlineOrSubsection: costlineOrSubsection, IsSelectionEnabled: item.IsSelectionEnabled, sectionId: item.Id, sectionIndex: sectionIndex, displayIndex: displayIndex, selectionType: item.SelectionType }"
                      [ngTemplateOutlet]="sectionTemplateSubsection">
                    </ng-template>
                  </ng-container>
                </ng-container>

                <div class="grid-footer">
                  <div class="grid-footer-row">
                    <div class="grid-column-total-label">
                      <span><span class="grid-total-label-name">{{ item.Name || "Product or Service" }}</span>
                        Total</span>
                    </div>
                    <div *ngIf="item.ShowsSectionUnit" class="grid-column quantity-col">
                      <span>{{ (item.Units || 0) + ' ' + (item.UnitType || ((item.Units > 1) ? "Units" : "Unit") )
                        }}</span>
                    </div>
                    <div *ngIf="item.ShowsSectionUnit" class="grid-column cost-col font-roboto">
                      <span>{{(item.Total > 0 && item.Units > 0 ? (item.Total) / (item.Units) : 0) |
                        formatNumber: {skipZerosAfterDecimal: true} }}</span>
                    </div>
                    <div class="grid-column price-col font-roboto">
                      <span>{{ item.Total || 0 | formatNumber }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="!estimate.IsItemized && !item.IsSelectionEnabled && !item.IsDisplayOnly">
              <div
                *ngIf="sectionIndex == 0 || estimateDetails.EstimateDetailsSections[sectionIndex-1]?.IsDisplayOnly || estimateDetails.EstimateDetailsSections[sectionIndex-1]?.IsSelectionEnabled"
                class="grid-labels"></div>
              <div class="cstm-grid-body
              {{(estimateDetails.EstimateDetailsSections[sectionIndex-1]?.IsDisplayOnly || estimateDetails.EstimateDetailsSections[sectionIndex-1]?.IsSelectionEnabled) ? 'upper-round-section': (sectionIndex != 0) ? 'upper-not-first-round-section' : ''}}
              {{(estimateDetails.EstimateDetailsSections[sectionIndex+1]?.IsDisplayOnly || estimateDetails.EstimateDetailsSections[sectionIndex+1]?.IsSelectionEnabled) ? 'bottom-round-section': ''}}
              {{sectionIndex==(estimateDetails.EstimateDetailsSections.length - 1) ? 'bottom-round-section':''}}">
                <div class="cstm-grid-body-row item-selectable">
                  <div class="cstm-grid-body-row-content">
                    <div class="grid-row-content-right">
                      <div class="grid-row-content-right-inner">
                        <div class="grid-column grid-items-description f-column">
                          <div class="grid-items-description-inner ">
                            <div class="grid-items-description__left">
                              <h5 class="text-break" style="font-size: 14px;">{{ item.Name || "Product or Service" }}
                              </h5>
                              <p *ngIf="item.ShowsSectionUnit" class="text-muted font-12 mb-0">
                                <span class="font-roboto">{{ item.Units }} {{ item.UnitType || (item.Units > 1 ? 'Units' : 'Unit') }}</span>
                                x
                                <span class="font-roboto">{{ ((item?.Total || 0) / item.Units).toFixed(2) | formatNumber }}</span>
                              </p>
                              <ng-container [ngTemplateOutlet]="clientVariableLine"
                                [ngTemplateOutletContext]="{ vars: item.ClientVisibleVariables }"></ng-container>
                            </div>
                          </div>

                          <ng-container *ngFor="let costlineOrSubsection of item.displayList">
                            <ng-container *ngIf="costlineOrSubsection.renderedType === renderTypes.costline">
                              <ng-container *ngIf="costlineOrSubsection.IsViewable">
                                <div class="grid-items-description-inner ">
                                  <div class="grid-items-description__left">
                                    <h4 class="text-break">
                                      {{
                                      costlineOrSubsection.OnlyShowCategoryName
                                      ? costlineOrSubsection.Category?.Name || ""
                                      : costlineOrSubsection.Name
                                      }}
                                      {{
                                      (costlineOrSubsection.OnlyShowCategoryName
                                      ? costlineOrSubsection.Category?.Name || ""
                                      : costlineOrSubsection.Name
                                      )?.length && costlineOrSubsection.QtyIsVisible
                                      ? " (" +
                                      costlineOrSubsection.DefaultQty + ' ' +
                                      (costlineOrSubsection.UnitType || ((costlineOrSubsection.DefaultQty > 1) ? "Units"
                                      : "Unit")) +
                                      ")"
                                      : ""
                                      }}
                                    </h4>
                                    <p class="text-break innerHtmlCkEditorContent" [innerHtml]="
                                                  costlineOrSubsection.Description | sanitize
                                                "></p>
                                  </div>
                                  <div class="grid-items-description__right">
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="costlineOrSubsection.renderedType === renderTypes.subsection">
                              <ng-container *ngIf="costlineOrSubsection.IsViewable">
                                <div class="grid-items-description-inner ">
                                  <div class="grid-items-description__left">
                                    <div class="grid-row-content-right subsection-item non-itemized-subsection">
                                      <div class="grid-row-content-right-inner mb-0">

                                        <!-- description column -->
                                        <div class="forced-width-100 grid-column grid-items-description f-column">
                                          <div class="grid-column-subsection w-100 pt-0">
                                            <p class="text-break" style="font-weight: 500; font-size: 12px;">
                                              <strong>{{ costlineOrSubsection.Name || "" }}</strong>
                                              <i>
                                                <small>
                                                  {{
                                                  costlineOrSubsection.ShowsSectionUnit
                                                  ? (costlineOrSubsection.Units || 0) +
                                                  " " +
                                                  (costlineOrSubsection.UnitType || ((costlineOrSubsection.Units >
                                                  1) ? "Units" : "Unit"))
                                                  : ""
                                                  }}
                                                  {{
                                                  costlineOrSubsection.ShowsSectionUnit &&
                                                  costlineOrSubsection.PriceIsVisible
                                                  ? " x " +
                                                  ((
                                                  costlineOrSubsection.Units > 0 && costlineOrSubsection.Total > 0 ?
                                                  ((costlineOrSubsection.Total) /
                                                  (costlineOrSubsection.Units)) : 0
                                                  ) | formatNumber: {skipZerosAfterDecimal: true})
                                                  : ""
                                                  }}
                                                </small>
                                              </i>
                                            </p>
                                            <ng-container [ngTemplateOutlet]="clientVariableLine"
                                              [ngTemplateOutletContext]="{ vars: costlineOrSubsection.ClientVisibleVariables }"></ng-container>
                                          </div>
                                          <div class="grid-items-description-inner px-2"
                                            *ngFor="let costline of costlineOrSubsection.EstimateCostLineItems; let first = first">
                                            <ng-container *ngIf="costline.IsViewable">
                                              <div class="grid-items-description__left">
                                                <h4 class="mb-1 text-break">
                                                  {{
                                                  costline.OnlyShowCategoryName
                                                  ? costline.Category?.Name
                                                  : costline.Name || costline.Props?.name || ""
                                                  }}
                                                  {{
                                                  (costline.OnlyShowCategoryName
                                                  ? costline.Category?.Name || ""
                                                  : costline.Name
                                                  )?.length && costline.QtyIsVisible
                                                  ? " (" +
                                                  costline.DefaultQty + ' ' +
                                                  (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" :
                                                  "Unit")) +
                                                  ")"
                                                  : ""
                                                  }}
                                                </h4>
                                                <p class="text-break innerHtmlCkEditorContent font-12" [innerHtml]="costline.Description | sanitize">
                                                </p>
                                              </div>
                                            </ng-container>
                                            <div class="grid-items-description__right">
                                            </div>
                                          </div>
                                        </div>

                                        <!-- Priced only once it has a line, like both print layouts: an unpriced
                                             subsection shows its name and variables, never a $0.00. -->
                                        <div
                                          class="grid-column price-col font-roboto sub-section-amount-non-itemized"
                                          *ngIf="costlineOrSubsection.EstimateCostLineItems?.length &&
                                        (estimateSettings?.DisplaySubsectionPriceOnEstimate ||
                                        (costlineOrSubsection.IsAssemblyOn &&
                                          costlineOrSubsection.PriceIsVisible))"
                                          [ngClass]="{'with-image':(item.ItemsFiles || []).length > 0}">
                                          <span class="">{{costlineOrSubsection.Total|formatNumber}}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="grid-items-description__right">

                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </div>
                        <!-- images for section costlines -->
                        <ng-container *ngIf="(item.ItemsFiles || []).length > 0">
                          <div class="costline-images">
                            <div class="main-image" (click)="openImageInFullScreen(item.ItemsFiles[0],item.ItemsFiles)">
                              <img
                                [src]="photoThumbUrl | memoizedFn : item.ItemsFiles[0] : $any(item.ItemsFiles[0])?._thumbFailed"
                                (error)="onThumbError(item.ItemsFiles[0])"
                                loading="lazy">
                            </div>
                            <div class="d-flex gap-1 mt-2">
                              <ng-container
                                *ngFor="let image of (item.ItemsFiles.length > 5 ? (item.ItemsFiles | slice:0:4) : item.ItemsFiles); let first = first;let last = last">
                                <div class="image-items d-flex align-items-center" *ngIf="!first"
                                  (click)="openImageInFullScreen(image,item.ItemsFiles)">
                                  <img [src]="photoThumbUrl | memoizedFn : image : $any(image)?._thumbFailed"
                                    (error)="onThumbError(image)"
                                    loading="lazy">
                                </div>
                                <ng-container *ngIf="item.ItemsFiles.length > 5">
                                  <div class="image-items d-flex align-items-center justify-content-center more-count"
                                    *ngIf="last">
                                    +{{ ((item.ItemsFiles).length - 4) }}
                                  </div>
                                </ng-container>
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
                        <div class="grid-column price-col">
                          <span>{{ item.Total || 0 | formatNumber }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <!-- Totals -->

        <ng-container *ngIf="estimate?.EstimateValues">
          <div class="cstm-grid-body line-items">
            <div class="cstm-grid-body-row item-selectable totals-line">
              <div class="cstm-grid-body-row-content">
                <div class="grid-row-content-right">
                  <div class="grid-row-content-right-inner m-0">
                    <div class="grid-column w-100">
                      <p style="font-weight: 500; text-align: right; font-size: 14px;">Subtotal</p>
                    </div>
                    <!-- price column -->
                    <div class="grid-column price-col font-roboto">
                      <span style="font-weight: 500; font-size: 14px;">{{
                        estimate?.EstimateValues?.TotalWithoutTax || 0
                        | formatNumber
                        }}</span>
                    </div>
                  </div>
                  <div class="grid-row-content-right-inner m-0"
                    *ngFor="let dis of estimate.Discounts | filterDiscounts: true">
                    <div class="grid-column w-100">
                      <p style="font-weight: 500; text-align: right; font-size: 14px;">
                        <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                          symbol: dis.IsPercentage ? "%" : "$",
                          appendSymbolAtStart: !dis.IsPercentage
                          } }})</strong>
                      </p>
                    </div>
                    <!-- price column -->
                    <div class="grid-column price-col font-roboto">
                      <span style="font-weight: 500; font-size: 14px;"><strong>-{{dis.DiscountedValue |
                          formatNumber}}</strong></span>
                    </div>
                  </div>
                  <div class="grid-row-content-right-inner m-0" *ngIf="!estimateSettings?.EstimateSalesTaxIsHidden">
                    <div class="grid-column w-100">
                      <p style="font-weight: 500; text-align: right; font-size: 11px;">Taxable Subtotal</p>
                    </div>
                    <!-- price column -->
                    <div class="grid-column price-col font-roboto">
                      <span style="font-weight: 500; font-size: 11px;">{{
                        estimate?.EstimateValues?.TaxableTotal || 0 | formatNumber
                        }}</span>
                    </div>
                  </div>
                  <div class="grid-row-content-right-inner m-0" *ngIf="!estimateSettings?.EstimateSalesTaxIsHidden">
                    <div class="grid-column w-100">
                      <p style="font-weight: 500; text-align: right; font-size: 14px;">Tax {{
                        estimate?.EstimateValues?.TaxPercentage
                        ? (estimate?.EstimateValues?.TaxPercentage || 0) + "%"
                        : ""
                        }}</p>
                    </div>
                    <!-- price column -->
                    <div class="grid-column price-col font-roboto">
                      <span style="font-weight: 500; font-size: 14px;">{{ estimate?.EstimateValues?.TotalTax || 0 |
                        formatNumber }}</span>
                    </div>
                  </div>

                  <div class="grid-row-content-right-inner m-0"
                    *ngFor="let dis of estimate.Discounts | filterDiscounts: false">
                    <div class="grid-column w-100">
                      <p style="font-weight: 500; text-align: right; font-size: 14px;">
                        <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                          symbol: dis.IsPercentage ? "%" : "$",
                          appendSymbolAtStart: !dis.IsPercentage
                          } }})</strong>
                      </p>
                    </div>
                    <!-- price column -->
                    <div class="grid-column price-col font-roboto">
                      <span style="font-weight: 500; font-size: 14px;"><strong>-{{dis.DiscountedValue |
                          formatNumber}}</strong></span>
                    </div>
                  </div>

                  <div class="grid-row-content-right-inner m-0" *ngIf="estimate.EstimateValues.TotalDiscount > 0">
                    <div class="grid-column w-100">
                      <div style="font-weight: 700; text-align: right; font-size: 16px;" class="total-discounted">
                        Total
                      </div>
                    </div>
                    <!-- price column -->
                    <div class="grid-column price-col font-roboto">
                      <span style="font-weight: 700;" [style.font-size]="getTotalFontSize(estimateCrossedOutTotal)"><strong>{{
                          estimateCrossedOutTotal
                          | formatNumber}}</strong></span>
                    </div>
                  </div>

                  <div class="grid-row-content-right-inner m-0">
                    <div class="grid-column w-100">
                      <p style="font-weight: 700; text-align: right; font-size: 16px;">Total</p>
                    </div>
                    <!-- price column -->
                    <div class="grid-column price-col font-roboto">
                      <span style="font-weight: 700;" [style.font-size]="getTotalFontSize((estimate?.EstimateValues?.TotalWithTax || 0) - (estimate?.EstimateValues?.TotalDiscount || 0))">{{
                        ((estimate?.EstimateValues?.TotalWithTax || 0) - (estimate?.EstimateValues?.TotalDiscount ||
                        0))
                        | formatNumber
                        }}</span>
                    </div>
                  </div>

                  <ng-container *ngIf="estimateDetails.EstimateType == estimateDetailTypeEnum.ChangeOrder">
                    <div class="grid-row-content-right-inner m-0">
                      <div class="grid-column w-100">
                        <p style="font-weight: 500; text-align: right; font-size: 14px;">Previous Project Total</p>
                      </div>
                      <!-- price column -->
                      <div class="grid-column price-col font-roboto">
                        <span style="font-weight: 500; font-size: 14px;">{{(estimateDetails.PreviousTotal||0) |
                          formatNumber}}</span>
                      </div>
                    </div>

                    <div class="grid-row-content-right-inner m-0">
                      <div class="grid-column w-100">
                        <p style="font-weight: 500; text-align: right; font-size: 14px;">Revised Project Total</p>
                      </div>
                      <!-- price column -->
                      <div class="grid-column price-col font-roboto">
                        <span style="font-weight: 500; font-size: 14px;">{{(estimateDetails.RevisedTotal||0) |
                          formatNumber}}</span>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </section>

      <!-- This section is only use for print preview -->
      <section *ngIf="!estimate?.IsItemized" class="show-print d-none clear-fix">
        <div class="line-items">
          <table class="line-item-table">
            <tbody class="line-item-table">
              <tr class="table-row header">
                <th class="header-cell">Description</th>
                <th class="header-cell amount-cell print-min-w">Prices</th>
              </tr>

              <ng-container>
                <ng-container *ngIf="estimateDetails.EstimateDetailsSections?.length || removedSections?.length">

                  <ng-container *ngIf="removedSections.length > 0">
                    <ng-template [ngTemplateOutletContext]="{colspan: 1 }" [ngTemplateOutlet]="removedItemsForPrint">
                    </ng-template>
                  </ng-container>
                  <ng-container *ngFor="
                  let item of orderSections(
                    estimateDetails.EstimateDetailsSections
                  )
                ">
                <ng-container *ngIf="item.IsDisplayOnly">
                  <tr tabindex="1" class="table-row">
                    <td class="table-cell line-item" style="overflow-wrap: break-word">
                      <h3 style="display: block">{{item.Name || "Product or Service"}}</h3>
                      <small>Removed from previous
                        <strong>{{
                          item.ModifiedFromSectionDetailsType ===
                          estimateDetailTypeEnum.Normal
                          ? "Estimate"
                          : "Change Order"
                          }}
                          :
                        </strong>
                        <strong style="
                            width: fit-content;
                            max-width: 60vw;
                            display: inline-block;
                            vertical-align: top;
                            margin-top: 0.4em;
                          ">{{ item.ModifiedFromSectionDetailsNumber }}</strong>
                      </small>
                    </td>
                    <td class="table-cell line-item amount-cell">
                      <span>{{ item.Total || 0 | formatNumber }}</span>
                    </td>
                  </tr>
                </ng-container>

                <ng-container
                  *ngIf="!item.IsDisplayOnly && (!item.IsSelectionEnabled || (item.IsSelectionEnabled && (checkIfAnyItemSelected(item.displayList) || estimateDetails?.ShowUnselectedInPrint)))">
                  <tr class="table-row" tabindex=" 1" [class.print-selection-section]="estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled">
                    <td class="table-cell line-item">
                      <h3>{{ item.Name || "Product or Service" }}</h3>
                      <ng-container [ngTemplateOutlet]="clientVariableLine"
                        [ngTemplateOutletContext]="{ vars: item.ClientVisibleVariables }"></ng-container>
                      <span *ngIf="estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled" class="selection-label">{{ getSelectionLabel(item.displayList, item.SelectionType) }}</span>

                      <div [class.print-selection-group]="estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled">
                      <div *ngFor="
                          let costlineOrSubsection of item.displayList;
                          let i = index
                        " class="intro-text"
                        [ngClass]="{'unselected-option': estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled && !costlineOrSubsection.IsSelectedForSelection && hasAnySelected(item.displayList), 'print-selection-item': estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled, 'print-selection-selected': estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled && costlineOrSubsection.IsSelectedForSelection}">
                        <ng-container *ngIf="item.IsSelectionEnabled">
                          <ng-container *ngIf="costlineOrSubsection.IsSelectedForSelection || estimateDetails?.ShowUnselectedInPrint">
                            <ng-container *ngIf="
                            costlineOrSubsection.renderedType ===
                            renderTypes.costline
                          ">
                              <!-- No `IsViewable` gate: everything under here is already inside
                                   `item.IsSelectionEnabled`, and a selection's DIRECT child cost
                                   lines are the options the client picks between, so they ignore
                                   the per-line eye toggle. Subsection children (below) are
                                   breakdown, not options, and still obey it. -->
                              <ng-container>
                                <span *ngIf="estimateDetails?.ShowUnselectedInPrint" class="selection-checkbox">{{ costlineOrSubsection.IsSelectedForSelection ? '☑' : '☐' }}</span>
                                <span *ngIf="estimateDetails?.ShowUnselectedInPrint && !costlineOrSubsection.IsSelectedForSelection && hasAnySelected(item.displayList)" class="optional-price-inline">{{ costlineOrSubsection.Price | formatNumber }} optional</span>
                                <span *ngIf="estimateDetails?.ShowUnselectedInPrint && !hasAnySelected(item.displayList)" class="optional-price-inline" style="color: inherit; font-style: normal;">{{ costlineOrSubsection.Price | formatNumber }}</span>
                                <h4>
                                  {{
                                  costlineOrSubsection.OnlyShowCategoryName
                                  ? costlineOrSubsection.Category?.Name || ""
                                  : costlineOrSubsection.Name
                                  }}
                                  {{
                                  (costlineOrSubsection.OnlyShowCategoryName
                                  ? costlineOrSubsection.Category?.Name || ""
                                  : costlineOrSubsection.Name
                                  )?.length && costlineOrSubsection.QtyIsVisible
                                  ? " (" +
                                  costlineOrSubsection.DefaultQty + ' ' +
                                  (costlineOrSubsection.UnitType || ((costlineOrSubsection.DefaultQty > 1) ? "Units" :
                                  "Unit")) +
                                  ")"
                                  : ""
                                  }}
                                </h4>
                                <p class="font-12 innerHtmlCkEditorContent" [innerHtml]="
                                costlineOrSubsection.Description | sanitize
                              "></p>
                              </ng-container>
                            </ng-container>

                            <ng-container *ngIf="
                            costlineOrSubsection.renderedType ===
                            renderTypes.subsection
                          ">
                              <!-- No `IsViewable` gate: already inside `item.IsSelectionEnabled`,
                                   and a subsection directly under a selection IS one of the
                                   options. Its child cost lines below stay breakdown and keep
                                   obeying `IsViewable`. -->
                              <ng-container>
                                <span *ngIf="estimateDetails?.ShowUnselectedInPrint" class="selection-checkbox">{{ costlineOrSubsection.IsSelectedForSelection ? '☑' : '☐' }}</span>
                                <span *ngIf="estimateDetails?.ShowUnselectedInPrint && !costlineOrSubsection.IsSelectedForSelection && hasAnySelected(item.displayList)" class="optional-price-inline">{{ costlineOrSubsection.Total | formatNumber }} optional</span>
                                <span *ngIf="estimateDetails?.ShowUnselectedInPrint && !hasAnySelected(item.displayList)" class="optional-price-inline" style="color: inherit; font-style: normal;">{{ costlineOrSubsection.Total | formatNumber }}</span>
                                <strong><i>{{ costlineOrSubsection?.Name }}</i></strong>

                                <i>

                                  <small>
                                    {{
                                    costlineOrSubsection.ShowsSectionUnit
                                    ? (costlineOrSubsection.Units || 0) +
                                    " " +
                                    (costlineOrSubsection.UnitType || ((costlineOrSubsection.Units > 1) ? "Units" :
                                    "Unit"))
                                    : ""
                                    }}
                                    {{
                                    costlineOrSubsection.ShowsSectionUnit &&
                                    costlineOrSubsection.PriceIsVisible
                                    ? " x " +
                                    ((
                                    costlineOrSubsection.Units > 0 && costlineOrSubsection.Total > 0 ?
                                    ((costlineOrSubsection.Total) /
                                    (costlineOrSubsection.Units)) : 0
                                    ) | formatNumber: {skipZerosAfterDecimal: true})
                                    : ""
                                    }}
                                  </small>
                                </i>
                                <ng-container [ngTemplateOutlet]="clientVariableLine"
                                  [ngTemplateOutletContext]="{ vars: costlineOrSubsection.ClientVisibleVariables }"></ng-container>
                                <!-- <span class="sub-section-amount" *ngIf="
                            estimateSettings?.DisplaySubsectionPriceOnEstimate ||
                            (costlineOrSubsection.IsAssemblyOn &&
                              costlineOrSubsection.PriceIsVisible)
                          ">{{costlineOrSubsection.Total|formatNumber}}</span> -->

                                <div *ngFor="
                                let costline of costlineOrSubsection.EstimateCostLineItems;
                                let i = index
                              " style="margin: 0 0 0.5em 1em">
                                  <ng-container *ngIf="i===0">
                                    <span
                                      [class]="costlineOrSubsection?.Name?'sub-section-amount sub-s-name-visibility font-roboto':'sub-section-amount font-roboto'"
                                      *ngIf="
                                estimateSettings?.DisplaySubsectionPriceOnEstimate ||
                                (costlineOrSubsection.IsAssemblyOn &&
                                  costlineOrSubsection.PriceIsVisible)
                              ">
                                      {{
                                      costlineOrSubsection.Total || 0 | formatNumber
                                      }}
                                    </span>
                                  </ng-container>
                                  <ng-container *ngIf="costline.IsViewable">
                                    <h4>
                                      {{
                                      costline.OnlyShowCategoryName
                                      ? costline.Category?.Name
                                      : costline.Name || costline.Props?.name || ""
                                      }}
                                      {{
                                      (costline.OnlyShowCategoryName
                                      ? costline.Category?.Name
                                      : costline.Name || costline.Props?.name || ""
                                      )?.length && costline.QtyIsVisible
                                      ? " (" +
                                      costline.DefaultQty + ' ' +
                                      (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" : "Unit")) +
                                      ")"
                                      : ""
                                      }}
                                    </h4>
                                    <p class="font-12 innerHtmlCkEditorContent" [innerHtml]="costline.Description | sanitize"></p>
                                  </ng-container>
                                </div>
                              </ng-container>
                            </ng-container>

                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!item.IsSelectionEnabled">
                          <ng-container *ngIf="
                            costlineOrSubsection.renderedType ===
                            renderTypes.costline
                          ">
                            <ng-container *ngIf="costlineOrSubsection.IsViewable">
                              <h4>
                                {{
                                costlineOrSubsection.OnlyShowCategoryName
                                ? costlineOrSubsection.Category?.Name || ""
                                : costlineOrSubsection.Name
                                }}
                                {{
                                (costlineOrSubsection.OnlyShowCategoryName
                                ? costlineOrSubsection.Category?.Name || ""
                                : costlineOrSubsection.Name
                                )?.length && costlineOrSubsection.QtyIsVisible
                                ? " (" +
                                costlineOrSubsection.DefaultQty + ' ' +
                                (costlineOrSubsection.UnitType || ((costlineOrSubsection.DefaultQty > 1) ? "Units" :
                                "Unit")) +
                                ")"
                                : ""
                                }}
                              </h4>
                              <p class="font-12 innerHtmlCkEditorContent" [innerHtml]="
                                costlineOrSubsection.Description | sanitize
                              "></p>
                            </ng-container>
                          </ng-container>

                          <ng-container *ngIf="
                            costlineOrSubsection.renderedType ===
                            renderTypes.subsection
                          ">
                            <ng-container *ngIf="costlineOrSubsection.IsViewable">

                              <strong><i>{{ costlineOrSubsection?.Name }}</i></strong>

                              <i>
                                <small>
                                  {{
                                  costlineOrSubsection.ShowsSectionUnit
                                  ? (costlineOrSubsection.Units || 0) +
                                  " " +
                                  (costlineOrSubsection.UnitType || ((costlineOrSubsection.Units > 1) ? "Units" :
                                  "Unit"))
                                  : ""
                                  }}
                                  {{
                                  costlineOrSubsection.ShowsSectionUnit &&
                                  costlineOrSubsection.PriceIsVisible
                                  ? " x " +
                                  ((
                                  costlineOrSubsection.Units > 0 && costlineOrSubsection.Total > 0 ?
                                  ((costlineOrSubsection.Total) /
                                  (costlineOrSubsection.Units)) : 0
                                  ) | formatNumber: {skipZerosAfterDecimal: true})
                                  : ""
                                  }}
                                </small>
                              </i>
                              <ng-container [ngTemplateOutlet]="clientVariableLine"
                                [ngTemplateOutletContext]="{ vars: costlineOrSubsection.ClientVisibleVariables }"></ng-container>
                              <!-- <span class="sub-section-amount" *ngIf="
                            estimateSettings?.DisplaySubsectionPriceOnEstimate ||
                            (costlineOrSubsection.IsAssemblyOn &&
                              costlineOrSubsection.PriceIsVisible)
                          ">{{costlineOrSubsection.Total|formatNumber}}</span> -->

                              <div *ngFor="
                                let costline of costlineOrSubsection.EstimateCostLineItems;
                                let i = index
                              " style="margin: 0 0 0.5em 1em">
                                <ng-container *ngIf="i===0">
                                  <span
                                    [class]="costlineOrSubsection?.Name?'sub-section-amount sub-s-name-visibility font-roboto':'sub-section-amount font-roboto'"
                                    *ngIf="
                                estimateSettings?.DisplaySubsectionPriceOnEstimate ||
                                (costlineOrSubsection.IsAssemblyOn &&
                                  costlineOrSubsection.PriceIsVisible)
                              ">
                                    {{
                                    costlineOrSubsection.Total || 0 | formatNumber
                                    }}
                                  </span>
                                </ng-container>
                                <ng-container *ngIf="costline.IsViewable">
                                  <h4>
                                    {{
                                    costline.OnlyShowCategoryName
                                    ? costline.Category?.Name
                                    : costline?.Name
                                    }}
                                    {{
                                    (costline.OnlyShowCategoryName
                                    ? costline.Category?.Name
                                    : costline?.Name
                                    )?.length && costline.QtyIsVisible
                                    ? " (" +
                                    costline.DefaultQty + ' ' +
                                    (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" : "Unit")) +
                                    ")"
                                    : ""
                                    }}
                                  </h4>
                                  <p class="font-12 innerHtmlCkEditorContent" [innerHtml]="costline.Description | sanitize"></p>
                                </ng-container>
                              </div>
                            </ng-container>
                          </ng-container>
                        </ng-container>



                      </div>
                      <div *ngIf="estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled && item.SelectionType === estimateSelectionType.OptionalSingleSelection"
                        class="intro-text print-selection-item"
                        [class.print-selection-selected]="!hasAnySelected(item.displayList)">
                        <span class="selection-checkbox">{{ !hasAnySelected(item.displayList) ? '☑' : '☐' }}</span>
                        <h4><em>None: decline all options</em></h4>
                      </div>
                      </div>
                    </td>
                    <td class="table-cell line-item amount-cell">
                      <div *ngIf="item.ShowsSectionUnit" class="value" style="margin-bottom: 5px">
                        <small>{{ (item.Units) + ' ' + (item.UnitType || ((item.Units > 1) ? "Units" : "Unit") ) }} x
                        </small>
                        <small>{{
                          ((item?.Total || 0) / item.Units).toFixed(2)
                          | formatNumber
                          }}</small>
                      </div>
                      <span>{{ item?.Total || 0 | formatNumber }}</span>
                    </td>
                  </tr>
                  <tr *ngIf="checkIfAnyItemFilesExists(item)">
                    <td colspan="4">
                      <div class="non-itemized-images-print">
                        <ng-container *ngIf="item.IsSelectionEnabled">
                          <ng-container *ngFor="let itemData of item.displayList">
                            <ng-container *ngIf="itemData.IsSelectedForSelection || estimateDetails?.ShowUnselectedInPrint">
                              <ng-container *ngFor="let image of itemData.ItemsFiles">
                                <div class="image-items d-flex align-items-center Medium">
                                  <img [src]="photoThumbUrl | memoizedFn : image : $any(image)?._thumbFailed"
                                    (error)="onThumbError(image)" loading="lazy">
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!item.IsSelectionEnabled">
                          <ng-container *ngFor="let image of item.ItemsFiles">
                            <div class="image-items d-flex align-items-center Medium">
                              <img [src]="photoThumbUrl | memoizedFn : image : $any(image)?._thumbFailed"
                                (error)="onThumbError(image)" loading="lazy">
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </ng-container>


                <!-- Total Calculation -->
                <tr class="table-row total-row">
                  <td class="table-cell f-100">
                    <div class="t-right"><span>Subtotal</span></div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="font-roboto">
                      {{
                      estimate?.EstimateValues?.TotalWithoutTax || 0
                      | formatNumber
                      }}
                    </div>
                  </td>
                </tr>

                <tr class="table-row total-row" *ngFor="let dis of estimate.Discounts | filterDiscounts: true">
                  <td class="table-cell f-100">
                    <div class="t-right">
                      <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                        symbol: dis.IsPercentage ? "%" : "$",
                        appendSymbolAtStart: !dis.IsPercentage
                        } }})</strong>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="px-2 ispostiscounted t-right font-roboto">
                      <strong>-{{dis.DiscountedValue | formatNumber}}</strong>
                    </div>
                  </td>
                </tr>

                <tr *ngIf="
                    !estimateSettings?.EstimateSalesTaxIsHidden
                  " class="table-row total-row">
                  <td class="table-cell f-100">
                    <div class="t-right"><small>Taxable Subtotal</small></div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="font-roboto">
                      <small>{{
                        estimate?.EstimateValues?.TaxableTotal || 0 | formatNumber
                        }}</small>
                    </div>
                  </td>
                </tr>

                <tr *ngIf="
                    !estimateSettings?.EstimateSalesTaxIsHidden
                  " class="table-row total-row">
                  <td class="table-cell f-100">
                    <div class="t-right">
                      Tax
                      <span *ngIf="!taxesPerLine">{{
                        estimate?.EstimateValues?.TaxPercentage
                        ? (estimate?.EstimateValues?.TaxPercentage || 0) + "%"
                        : ""
                        }}</span>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="font-roboto">
                      {{ estimate?.EstimateValues?.TotalTax || 0 | formatNumber }}
                    </div>
                  </td>
                </tr>

                <tr class="table-row total-row" *ngFor="let dis of estimate.Discounts | filterDiscounts: false">
                  <td class="table-cell f-100">
                    <div class="t-right">
                      <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                        symbol: dis.IsPercentage ? "%" : "$",
                        appendSymbolAtStart: !dis.IsPercentage
                        } }})</strong>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="px-2 ispostiscounted t-right font-roboto">
                      <strong>-{{dis.DiscountedValue | formatNumber}}</strong>
                    </div>
                  </td>
                </tr>

                <tr *ngIf="estimate.EstimateValues.TotalDiscount > 0" class="table-row total-row">
                  <td class="table-cell f-100 t-right">
                    <div class="total-discounted-print">
                      Total
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="total-discounted-print font-roboto">
                      <span style="padding-left: 5px">{{ estimateCrossedOutTotal | formatNumber}}</span>
                    </div>
                  </td>
                </tr>

                <!-- discounted-total -->
                <tr class="table-row total-row">
                  <td class="table-cell f-100">
                    <div class="t-right">
                      <strong class="total">Total</strong>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="total font-roboto">
                      <strong>{{
                        ((estimate?.EstimateValues?.TotalWithTax || 0) - (estimate?.EstimateValues?.TotalDiscount || 0))
                        | formatNumber
                        }}</strong>
                    </div>
                  </td>
                </tr>


                <ng-container *ngIf="estimateDetails.EstimateType == estimateDetailTypeEnum.ChangeOrder">
                  <tr class="table-row total-row">
                    <td class="table-cell f-100">
                      <div class="t-right">
                        <span>Previous Project Total</span>
                      </div>
                    </td>
                    <td class="table-cell amount-cell variable">
                      <div class="font-roboto">
                        <span>{{(estimateDetails.PreviousTotal||0) | formatNumber}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr class="table-row total-row">
                    <td class="table-cell f-100">
                      <div class="t-right">
                        <span>Revised Project Total</span>
                      </div>
                    </td>
                    <td class="table-cell amount-cell variable">
                      <div class="font-roboto">
                        <span>{{(estimateDetails.RevisedTotal||0) | formatNumber}}</span>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>

          <div class="non-itemized-images-print" *ngIf="visibility.ShowAttachments">
            <ng-container *ngFor="let image of photosList">
              <div class="image-items d-flex align-items-center Medium">
                <img [src]="photoThumbUrl | memoizedFn : image : $any(image)?._thumbFailed"
                  (error)="onThumbError(image)" loading="lazy">
              </div>
            </ng-container>
          </div>
        </div>
      </section>

      <!-- This section is only use for print preview -->
      <section *ngIf="estimate?.IsItemized" class="show-print d-none clear-fix">
        <div class="line-items">
          <table class="line-item-table">
            <tbody class="line-item-table">
              <tr class="table-row header">
                <th class="header-cell" [colSpan]="isAllQuantityViewAble ? undefined : 3">
                  Description
                </th>
                <th class="header-cell amount-cell" *ngIf="isAllQuantityViewAble">
                  QTY
                </th>
                <th class="header-cell amount-cell" *ngIf="isAllQuantityViewAble">
                  COST
                </th>
                <th class="header-cell amount-cell">Price</th>
              </tr>

              <ng-container *ngIf="estimateDetails.EstimateDetailsSections?.length || removedSections?.length">

                <ng-container *ngIf="removedSections.length > 0">
                  <ng-template [ngTemplateOutletContext]="{colspan: 3 }" [ngTemplateOutlet]="removedItemsForPrint">
                  </ng-template>
                </ng-container>

                <ng-container *ngFor="
                    let item of orderSections(
                      estimateDetails.EstimateDetailsSections
                    )
                  ">
                  <ng-container *ngIf="item.IsDisplayOnly">
                    <tr tabindex="1" class="table-row">
                      <td class="table-cell line-item" [colSpan]="3" style="overflow-wrap: break-word">
                        <h3 style="display: block">{{item.Name || "Product or Service"}}</h3>
                        <small>Removed from previous
                          <strong>{{
                            item.ModifiedFromSectionDetailsType ===
                            estimateDetailTypeEnum.Normal
                            ? "Estimate"
                            : "Change Order"
                            }}
                            :
                          </strong>
                          <strong style="
                              width: fit-content;
                              max-width: 60vw;
                              display: inline-block;
                              vertical-align: top;
                              margin-top: 0.4em;
                            ">{{ item.ModifiedFromSectionDetailsNumber }}</strong>
                        </small>
                      </td>
                      <td class="table-cell line-item amount-cell">
                        <span>{{ item.Total || 0 | formatNumber }}</span>
                      </td>
                    </tr>
                  </ng-container>

                  <ng-container
                    *ngIf="!item.IsDisplayOnly && (!item.IsSelectionEnabled || (item.IsSelectionEnabled && (checkIfAnyItemSelected(item.displayList) || estimateDetails?.ShowUnselectedInPrint)))">
                    <tr class="table-row" tabindex="1" [class.print-selection-section]="estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled">
                      <td class="table-cell line-item title">
                        <h3>{{ item?.Name || "Product or Service" }}</h3>
                        <ng-container [ngTemplateOutlet]="clientVariableLine"
                          [ngTemplateOutletContext]="{ vars: item.ClientVisibleVariables }"></ng-container>
                        <span *ngIf="estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled" class="selection-label">{{ getSelectionLabel(item.displayList, item.SelectionType) }}</span>
                      </td>
                    </tr>

                    <ng-container *ngFor="let costlineOrSubsection of item.displayList">
                      <!-- <tr><td>item selection: {{costlineOrSubsection.IsSelectedForSelection}}</td></tr> -->
                      <ng-container *ngIf="
                          costlineOrSubsection.renderedType ===
                          renderTypes.costline
                        ">
                        <ng-container *ngIf="item.IsSelectionEnabled">
                          <ng-container *ngIf="costlineOrSubsection.IsSelectedForSelection || estimateDetails?.ShowUnselectedInPrint">
                            <ng-template [ngTemplateOutletContext]="{
                              costline: costlineOrSubsection,
                              column: isAllQuantityViewAble ? undefined : 3,
                              showCheckbox: estimateDetails?.ShowUnselectedInPrint,
                              isUnselected: !costlineOrSubsection.IsSelectedForSelection,
                              anySelected: hasAnySelected(item.displayList)
                            }" [ngTemplateOutlet]="sectionTemplateForPrint">
                            </ng-template>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!item.IsSelectionEnabled">
                          <ng-template [ngTemplateOutletContext]="{
                            costline: costlineOrSubsection,
                            column: isAllQuantityViewAble ? undefined : 3
                          }" [ngTemplateOutlet]="sectionTemplateForPrint">
                          </ng-template>
                        </ng-container>
                      </ng-container>

                      <ng-container *ngIf="
                          costlineOrSubsection.renderedType ===
                          renderTypes.subsection && (estimate?.IsItemized || costlineOrSubsection.IsViewable)
                        ">
                        <!-- -----here---- -->
                        <ng-container *ngIf="item.IsSelectionEnabled">
                          <ng-container *ngIf="costlineOrSubsection.IsSelectedForSelection || estimateDetails?.ShowUnselectedInPrint">
                            <ng-template [ngTemplateOutletContext]="{ costlineOrSubsection:costlineOrSubsection, showCheckbox: estimateDetails?.ShowUnselectedInPrint, isUnselected: !costlineOrSubsection.IsSelectedForSelection, anySelected: hasAnySelected(item.displayList) }"
                              [ngTemplateOutlet]="itemizePrintDisplaySubsesction"></ng-template>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="!item.IsSelectionEnabled">
                          <ng-template [ngTemplateOutletContext]="{ costlineOrSubsection:costlineOrSubsection }"
                            [ngTemplateOutlet]="itemizePrintDisplaySubsesction"></ng-template>
                        </ng-container>
                      </ng-container>
                    </ng-container>

                    <tr *ngIf="estimateDetails?.ShowUnselectedInPrint && item.IsSelectionEnabled && item.SelectionType === estimateSelectionType.OptionalSingleSelection"
                      class="table-row print-selection-item"
                      [class.print-selection-selected]="!hasAnySelected(item.displayList)">
                      <td [colSpan]="isAllQuantityViewAble ? undefined : 3" class="table-cell line-item title">
                        <span class="selection-checkbox">{{ !hasAnySelected(item.displayList) ? '☑' : '☐' }}</span>
                        <h4 style="display:inline"><em>None: decline all options</em></h4>
                      </td>
                      <td *ngIf="isAllQuantityViewAble" class="table-cell line-item amount-cell"></td>
                      <td *ngIf="isAllQuantityViewAble" class="table-cell line-item amount-cell"></td>
                      <td class="table-cell line-item amount-cell"></td>
                    </tr>

                    <tr class="table-row">
                      <td [colSpan]="item.ShowsSectionUnit ? undefined : 3" class="table-cell line-item title t-right">
                        <small>{{ item.Name || "Product or Service" }} Total</small>
                      </td>
                      <td *ngIf="item.ShowsSectionUnit" class="table-cell line-item amount-cell">
                        <small>{{ (item.Units || 0) + ' ' + (item.UnitType || ((item.Units > 1) ? "Units" : "Unit") )
                          }}</small>
                      </td>
                      <td class="table-cell line-item amount-cell" *ngIf="item.ShowsSectionUnit">
                        <small>{{(item.Total > 0 && item.Units > 0 ? (item.Total) / (item.Units) : 0) |
                          formatNumber: {skipZerosAfterDecimal: true} }}</small>
                      </td>
                      <td class="table-cell line-item amount-cell">
                        <span>{{ item.Total || 0 | formatNumber }}</span>
                      </td>
                    </tr>
                  </ng-container>

                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div class="line-items">
          <table>
            <tbody class="line-item-table">
              <ng-container *ngIf="estimate?.EstimateValues">
                <!-- Total Calculation -->
                <tr class="table-row total-row">
                  <td colspan="3" class="table-cell f-100">
                    <div class="t-right"><span>Subtotal</span></div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div>
                      {{
                      estimate?.EstimateValues?.TotalWithoutTax || 0
                      | formatNumber
                      }}
                    </div>
                  </td>
                </tr>
                <tr class="table-row total-row" *ngFor="let dis of estimate.Discounts | filterDiscounts: true">
                  <td colspan="3" class="table-cell f-100">
                    <div class="t-right">
                      <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                        symbol: dis.IsPercentage ? "%" : "$",
                        appendSymbolAtStart: !dis.IsPercentage
                        } }})</strong>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="px-2 ispostiscounted t-right">
                      <strong>-{{dis.DiscountedValue | formatNumber}}</strong>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="
                    !estimateSettings?.EstimateSalesTaxIsHidden
                  " class="table-row total-row">
                  <td colspan="3" class="table-cell f-100">
                    <div class="t-right"><small>Taxable Subtotal</small></div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div>
                      <small>{{
                        estimate?.EstimateValues?.TaxableTotal || 0 | formatNumber
                        }}</small>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="
                    !estimateSettings?.EstimateSalesTaxIsHidden
                  " class="table-row total-row">
                  <td colspan="3" class="table-cell f-100">
                    <div class="t-right">
                      Tax
                      {{
                      estimate?.EstimateValues?.TaxPercentage
                      ? (estimate?.EstimateValues?.TaxPercentage || 0) + "%"
                      : ""
                      }}
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div>
                      {{ estimate?.EstimateValues?.TotalTax || 0 | formatNumber }}
                    </div>
                  </td>
                </tr>
                <tr class="table-row total-row" *ngFor="let dis of estimate.Discounts | filterDiscounts: false">
                  <td colspan="3" class="table-cell f-100">
                    <div class="t-right">
                      <strong>{{dis.Name}} ({{dis.Value | formatNumber: {
                        symbol: dis.IsPercentage ? "%" : "$",
                        appendSymbolAtStart: !dis.IsPercentage
                        } }})</strong>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="px-2 ispostiscounted t-right">
                      <strong>-{{dis.DiscountedValue | formatNumber}}</strong>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="estimate.EstimateValues.TotalDiscount > 0" class="table-row total-row">
                  <td colspan="3" class="table-cell f-100 t-right">
                    <div class="total-discounted-print">
                      Total
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="total-discounted-print">
                      <span style="padding-left: 5px">{{ estimateCrossedOutTotal | formatNumber}}</span>
                    </div>
                  </td>
                </tr>
                <tr class="table-row total-row">
                  <td colspan="3" class="table-cell f-100">
                    <div class="t-right">
                      <strong class="total">Total</strong>
                    </div>
                  </td>
                  <td class="table-cell amount-cell variable">
                    <div class="total">
                      <strong>{{
                        ((estimate?.EstimateValues?.TotalWithTax || 0) - (estimate?.EstimateValues?.TotalDiscount ||
                        0))
                        | formatNumber
                        }}</strong>
                    </div>
                  </td>
                </tr>

                <ng-container *ngIf="estimateDetails.EstimateType == estimateDetailTypeEnum.ChangeOrder">
                  <tr class="table-row total-row">
                    <td colspan="3" class="table-cell f-100">
                      <div class="t-right">
                        <span>Previous Project Total</span>
                      </div>
                    </td>
                    <td class="table-cell amount-cell variable">
                      <div>
                        <span>{{(estimateDetails.PreviousTotal || 0) | formatNumber}}</span>
                      </div>
                    </td>
                  </tr>
                  <tr class="table-row total-row">
                    <td colspan="3" class="table-cell f-100">
                      <div class="t-right">
                        <span>Revised Project Total</span>
                      </div>
                    </td>
                    <td class="table-cell amount-cell variable">
                      <div>
                        <span>{{(estimateDetails.RevisedTotal || 0) | formatNumber}}</span>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div class="non-itemized-images-print" *ngIf="visibility.ShowAttachments">
          <ng-container *ngFor="let image of estimate.Files">
            <div class="image-items d-flex align-items-center Medium">
              <img [src]="photoThumbUrl | memoizedFn : image : $any(image)?._thumbFailed"
                (error)="onThumbError(image)" loading="lazy">
            </div>
          </ng-container>
        </div>
      </section>

      <!-- Contact Details -->
      <section *ngIf="visibility.ShowContractDetails && estimateDetails?.EstimateContactDetails">
        <div class="introduction">
          <div class="intro-text description-inner innerHtmlCkEditorContent">
            <p [innerHtml]="estimateDetails?.EstimateContactDetails | sanitize"></p>
          </div>
        </div>
      </section>

      <!-- Files and Photos -->
      <section class="clear-fix" *ngIf="visibility.ShowAttachments">
        <h5 *ngIf="filesList.length" style="color: gray">Files</h5>
        <div *ngIf="filesList.length" class="estimate-gallery ">
          <div class="gallery-holder">
            <div class="gallery" style="min-height: 70px">
              <div>
                <div class="file-list">
                  <a *ngFor="let item of filesList"
                    [href]="item?.UriPath + ( $any(item?.FileNameURI)|| $any(item?.FileName)) " class="file-item"
                    rel="noopener noreferrer" target="_blank">
                    <div class="file-block">
                      <div class="focus-block back-">
                        <ng-container [ngSwitch]="item.FileExtension">
                          <i *ngSwitchCase="'.xlsx'" class="i-file-excel-1"></i>
                          <i *ngSwitchCase="'.pptx'" class="i-file-powerpoint"></i>
                          <i *ngSwitchCase="'.doc'" class="i-file-word-1"></i>
                          <i *ngSwitchCase="'.csv'" class="i-file-csv"></i>
                          <i *ngSwitchCase="'.pdf'" class="i-file-pdf-1"></i>
                          <i *ngSwitchCase="'.rar'" class="i-file-archive-1"></i>
                          <i *ngSwitchDefault class="i-file"></i>
                        </ng-container>
                      </div>
                      <div class="content">
                        <strong>{{ item?.DisplayName }}</strong><small>{{ item?.FileName }}</small><small></small>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <h5 *ngIf="photosList.length" style="color: gray" class="hide-print">Photos</h5>
        <div class="estimate-gallery hide-print">
          <div class="gallery-holder" id="projul-gallery">
            <div class="gallery" style="min-height: 90px">
              <div class="card-wrapper">
                <div *ngFor="let item of photosList" class="card-item">
                  <div class="card-image" (click)="openImageInFullScreen(item,photosList)">
                    <img [src]="photoThumbUrl | memoizedFn : item : $any(item)?._thumbFailed"
                      (error)="onThumbError(item)" alt="" height="90"
                      width="120" loading="lazy" />
                  </div>
                  <div class="card-name mt-2">
                    <span title="download.png">{{ item?.DisplayName }}</span>
                  </div>
                  <div class="card-date">
                    {{ item?.DateUploaded | date : "medium" }}
                  </div>
                  <div class="card-desc"></div>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </section>

      <div class="hide-print">
        <!-- Print Button Section -->

        <section style="margin-top: 2rem" class="mob-hide">
          <div class="f-row f-center d-lg-flex d-none">
            <button (click)="handlePrintPDF()" class="round no-border no-transform">
              <i class="i-print"></i>
              <span>Print
                {{
                estimateDetails?.Name == "Change Order"
                ? estimateDetails?.Name?.toLowerCase()
                : estimate?.EstimateAlias?.toLowerCase()
                }}
                {{ estimateDetails?.EstimateNumber }}</span>
            </button>
          </div>
        </section>
        <ng-container *ngIf="estimateDetails?.CustomerCanApproveReject">
          <ng-container *ngIf="estimateDetails.AcceptedRejectedRevisionBy != acceptedRejectedRevisionBy.Company">
            <!-- ShowSignature governs the printed signature block, whose client-side analogue is this
              post-approval confirmation. It is display only and never gates accepting. -->
            <div *ngIf="visibility.ShowSignature && status == estimateStatusTypes.Approved && !newlyStatusUpdated"
              style="max-width: 500px">
              <div style="margin-bottom: 0.5rem">
                <h3>
                  <i class="i-check-circle"></i><span style="margin-left: 0.5rem">{{
                    estimateDetails?.Name == "Change Order"
                    ? estimateDetails?.Name
                    : estimate?.EstimateAlias
                    }}
                    Accepted</span>
                </h3>
              </div>
              <div class="signed-line">
                <span>{{ estimateDetails.CustomerFullName }} </span><span>{{
                  estimateDetails.ApprovedDate | date : "mediumDate"
                  }}</span>
              </div>
              <div>
                <span>{{ estimateDetails.CustomerFullName }} </span>
              </div>
            </div>

            <div *ngIf="status == estimateStatusTypes.RevisionRequested && !newlyStatusUpdated"
              class="ReactCollapse--content">
              <div style="max-width: 500px">
                <div style="margin-bottom: 0.5rem">
                  <h3 class="f-row f-a-center">
                    <i class="i-check-circle"></i><span>Revision Request Sent</span>
                  </h3>
                </div>
                <div style="margin: 1rem 0"><span>Changed your mind?</span></div>
              </div>
            </div>

            <ng-container *ngIf="status == estimateStatusTypes.Rejected && !newlyStatusUpdated">
              <div style="max-width: 500px">
                <div style="margin-bottom: 0.5rem">
                  <h3 class="f-row f-a-center">
                    <i class="i-check-circle"></i><span>Rejection Sent</span>
                  </h3>
                </div>
                <div style="margin: 1rem 0"><span>Changed your mind?</span></div>
              </div>
            </ng-container>
          </ng-container>

          <section>
            <div aria-hidden="false" class="ReactCollapse--collapse" style="height: auto; overflow: initial">
              <div class="ReactCollapse--content">
                <div *ngIf="isClosed && !isCollapsed" class="d-flex justify-content-center" style="padding: 2rem 0">
                  <small class="text-muted"><strong>This {{estimate?.EstimateAlias?.toLowerCase()}} has been closed. Please contact the company for more information.</strong></small>
                </div>
                <div *ngIf="!isCollapsed && !isClosed" class="button-row" style="padding: 2rem 0">
                  <div class="d-flex flex-column align-items-center">
                    <button [appLogEvent] (click)="showContent(estimateStatusTypes.Approved)" *ngIf="showAcceptAndSign"
                      [attr.aria-expanded]="isCollapsed" [disabled]="isDueDate" aria-controls="collapseBasic"
                      class="round call-to-action no-transform" style="line-height: 1.1">
                      <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.05625 7.79375C9.96875 7.11875 10.6812 6.37813 11.1937 5.57188C11.7062 4.76562 11.9625 3.9625 11.9625 3.1625C11.9625 2.7625 11.8969 2.46875 11.7656 2.28125C11.6344 2.09375 11.4562 2 11.2312 2C10.6437 2 10.125 2.49688 9.675 3.49063C9.225 4.48438 9 5.60625 9 6.85625C9 7.03125 9.00312 7.19688 9.00937 7.35313C9.01562 7.50938 9.03125 7.65625 9.05625 7.79375ZM0.75 14.75V13.25H2.25V14.75H0.75ZM3.75 14.75V13.25H5.25V14.75H3.75ZM6.75 14.75V13.25H8.25V14.75H6.75ZM9.75 14.75V13.25H11.25V14.75H9.75ZM12.75 14.75V13.25H14.25V14.75H12.75ZM1.05 11.75L0 10.7L1.2 9.5L0 8.3L1.05 7.25L2.25 8.45L3.45 7.25L4.5 8.3L3.3 9.5L4.5 10.7L3.45 11.75L2.25 10.55L1.05 11.75ZM10.0875 11C9.7125 11 9.36875 10.9281 9.05625 10.7844C8.74375 10.6406 8.475 10.4062 8.25 10.0813C7.9375 10.2563 7.61562 10.4125 7.28437 10.55C6.95312 10.6875 6.6125 10.825 6.2625 10.9625L5.7375 9.55625C6.0875 9.43125 6.42187 9.29688 6.74062 9.15313C7.05937 9.00938 7.36875 8.85625 7.66875 8.69375C7.60625 8.41875 7.55937 8.11875 7.52812 7.79375C7.49687 7.46875 7.48125 7.11875 7.48125 6.74375C7.48125 4.94375 7.8375 3.45312 8.55 2.27188C9.2625 1.09063 10.1562 0.5 11.2312 0.5C11.8812 0.5 12.4125 0.740625 12.825 1.22188C13.2375 1.70312 13.4437 2.375 13.4437 3.2375C13.4437 4.3125 13.1031 5.375 12.4219 6.425C11.7406 7.475 10.7937 8.41875 9.58125 9.25625C9.66875 9.34375 9.75937 9.40938 9.85312 9.45312C9.94687 9.49688 10.0437 9.51875 10.1437 9.51875C10.4687 9.51875 10.8469 9.3125 11.2781 8.9C11.7094 8.4875 12.1 7.94375 12.45 7.26875L13.8187 7.90625C13.7312 8.11875 13.6625 8.375 13.6125 8.675C13.5625 8.975 13.5687 9.2375 13.6312 9.4625C13.7562 9.4 13.9031 9.29375 14.0719 9.14375C14.2406 8.99375 14.4125 8.80625 14.5875 8.58125L15.7687 9.5C15.4437 9.95 15.0687 10.3125 14.6437 10.5875C14.2187 10.8625 13.825 11 13.4625 11C13.2 11 12.9656 10.9219 12.7594 10.7656C12.5531 10.6094 12.3812 10.3688 12.2437 10.0438C11.8937 10.3563 11.5375 10.5938 11.175 10.7563C10.8125 10.9188 10.45 11 10.0875 11Z"
                          id="#signatureSVG" />
                      </svg>
                      <span class="f-column f-a-start ms-3">
                        <span>Accept and sign
                          {{
                          estimateDetails?.Name == "Change Order"
                          ? (estimateDetails?.Name)?.toLowerCase()
                          : estimate?.EstimateAlias?.toLowerCase()
                          }}</span>

                      </span>
                    </button>
                    <small *ngIf="isDueDate && !isNoLongerALiveOffer" class="danger"><strong>This
                        {{estimate?.EstimateAlias?.toLowerCase()}} has expired</strong></small>
                  </div>

                  <button  [appLogEvent] (click)="showContent(estimateStatusTypes.RevisionRequested)" *ngIf="showRequestRevision"
                    class="round border-dark no-transform">
                    <img src="../../../assets/img/revesion.svg" class="me-3">
                    <span>Request revision</span>
                  </button>
                  <button [appLogEvent] (click)="showContent(estimateStatusTypes.Rejected)" *ngIf="showReject"
                    class="round border-dark no-transform">
                    <img src="../../../assets/img/cross.svg" class="me-3">
                    <span>Reject
                      {{
                      estimateDetails?.Name == "change Order"
                      ? estimateDetails?.Name?.toLowerCase()
                      : estimate?.EstimateAlias?.toLowerCase()
                      }}</span>
                  </button>
                </div>

                <div [collapse]="!isCollapsed" class="ReactCollapse--show-content" id="collapseBasic">
                  <div class="form-collapse-content">
                    <!-- Accept and Sign Collapse start  -->
                    <div *ngIf="showAcceptAndSign" class="form-collapse-one">
                      <div class="f-row">
                        <h2 class="f-grow">
                          Accept and sign
                          {{
                          estimateDetails?.Name == "change order"
                          ? estimateDetails?.Name?.toLowerCase()
                          : estimate?.EstimateAlias?.toLowerCase()
                          }}
                        </h2>
                        <span class="f-row f-a-center">
                          <button (click)="buttonStateMaintain(status)" class="round">
                            <i class="i-cross"></i>
                            <span>cancel</span>
                          </button>
                        </span>
                      </div>

                      <!-- ShowSignature must never gate this pad or the Accept and sign button: accepting
                        online is a workflow owned by CustomerCanApproveReject, not a display toggle. -->
                      <projul-signature-pad (formSubmitBody)="submitResponse($event)" [estimate]="estimate"
                        [portalEstimate]="portalEstimate">
                      </projul-signature-pad>
                    </div>

                    <!-- Request Revision Collapse start -->
                    <div [formGroup]="requestRevisionForm">
                      <div *ngIf="showRequestRevision" class="form-collapse-two">
                        <div class="f-row">
                          <h2 class="f-grow">
                            Request
                            {{
                            estimateDetails?.Name == "Change Order"
                            ? estimateDetails?.Name
                            : estimate?.EstimateAlias
                            }}
                            Revision
                          </h2>
                          <span class="f-row f-a-center">
                            <button (click)="buttonStateMaintain(status)" class="round">
                              <i class="i-cross"></i>
                              <span>cancel</span>
                            </button>
                          </span>
                        </div>
                        <div>
                          <p *ngIf="nameError" style="margin-bottom: 0.5rem">
                            <span class="error">Enter your full name</span> and
                            then <span class="">sign in the box below</span>.
                          </p>
                        </div>

                        <div>
                          <p style="margin-bottom: 0.5rem">
                            <span class="">Enter your full name</span> and your
                            revision request.
                          </p>
                        </div>
                        <div class="f-row f-a-center">
                          <input [ngClass]="{
                            'is-invalid':
                              revisionControls['FullName'].invalid &&
                              (revisionControls['FullName'].dirty ||
                                revisionControls['FullName'].touched)
                          }" class="square" formControlName="FullName" placeholder="Your full name" type="text"
                            value="" />
                          <span class="f-grow"></span>
                          <span style="margin-left: 1rem">Date Requested: {{ todayDate }}</span>
                        </div>
                        <div>
                          <textarea [ngClass]="{
                            'is-invalid':
                              revisionControls['Reason'].invalid &&
                              (revisionControls['Reason'].dirty ||
                                revisionControls['Reason'].touched)
                          }" class="square" formControlName="Reason" placeholder="Requested revisions..."></textarea>
                        </div>
                        <div class="f-row">
                          <span class="f-grow"></span>
                          <button [appLogEvent] (click)="submitRevision()" class="call-to-action round">
                            <i class="i-check_mark"></i>
                            <span>submit revision request</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Reject Collapse start -->
                    <div [formGroup]="rejectForm">
                      <div *ngIf="showReject" class="form-collapse-three">
                        <div class="f-row">
                          <h2 class="f-grow">
                            Reject
                            {{
                            estimateDetails?.Name == "Change Order"
                            ? estimateDetails?.Name
                            : estimate?.EstimateAlias
                            }}
                          </h2>
                          <span class="f-row f-a-center">
                            <button (click)="buttonStateMaintain(status)" class="round">
                              <i class="i-cross"></i>
                              <span>cancel</span>
                            </button>
                          </span>
                        </div>
                        <div>
                          <p *ngIf="nameError" style="margin-bottom: 0.5rem">
                            <span class="error">Enter your full name</span> and
                            then <span class="">sign in the box below</span>.
                          </p>
                        </div>
                        <div>
                          <p style="margin-bottom: 0.5rem">
                            <span class="">Enter your full name</span> and a
                            reason for rejecting.
                          </p>
                        </div>
                        <div class="f-row f-a-center">
                          <input [ngClass]="{
                            'is-invalid':
                              rejectControls['FullName'].invalid &&
                              (rejectControls['FullName'].dirty ||
                                rejectControls['FullName'].touched)
                          }" class="square" formControlName="FullName" placeholder="Your full name" type="text"
                            value="" />
                          <span class="f-grow"></span>
                          <span style="margin-left: 1rem">Date Rejected: {{ todayDate }}</span>
                        </div>
                        <div>
                          <textarea [ngClass]="{
                            'is-invalid':
                              rejectControls['FullName'].invalid &&
                              (rejectControls['Reason'].dirty ||
                                rejectControls['Reason'].touched)
                          }" class="square" formControlName="Reason" placeholder="Reason for rejecting..."></textarea>
                        </div>
                        <div class="f-row">
                          <span class="f-grow"></span>
                          <button [appLogEvent] (click)="submitRejection()" class="call-to-action round">
                            <i class="i-check_mark"></i>
                            <span>submit rejection</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Spinner -->
                <projul-spinner [isSpinner]="showLoader" [text]="spinnerLabel"></projul-spinner>

                <div *ngIf="apiSuccessResponse" style="margin-bottom: 0.5rem">
                  <h3>
                    <i *ngIf="!isErrorFromApi" class="i-check-circle"></i><span style="margin-left: 0.5rem">{{
                      actionText }}</span>
                  </h3>
                </div>
              </div>
            </div>
          </section>
        </ng-container>
      </div>
    </ng-container>
  </div>


</section>

<div class="background-loader" *ngIf="isLoading">
  <div class="sk-cube-grid">
    <div class="sk-cube sk-cube9"></div>
    <div class="sk-cube sk-cube8"></div>
    <div class="sk-cube sk-cube7"></div>
    <div class="sk-cube sk-cube6"></div>
    <div class="sk-cube sk-cube5"></div>
    <div class="sk-cube sk-cube4"></div>
    <div class="sk-cube sk-cube3"></div>
    <div class="sk-cube sk-cube2"></div>
    <div class="sk-cube sk-cube1"></div>
  </div>
</div>

<ng-template #itemizePrintDisplaySubsesction let-costlineOrSubsection="costlineOrSubsection" let-showCheckbox="showCheckbox" let-isUnselected="isUnselected" let-anySelected="anySelected">
  <tr class="table-row" tabindex="1" [ngClass]="{'unselected-option': isUnselected && anySelected, 'print-selection-item': showCheckbox, 'print-selection-selected': showCheckbox && !isUnselected}">
    <td colSpan="3" class="table-cell line-item title">
      <span *ngIf="showCheckbox" class="selection-checkbox">{{ isUnselected ? '☐' : '☑' }}</span>
      <strong><i class="font-12">{{ costlineOrSubsection.Name || "" }}
          <ng-container *ngIf="!costlineOrSubsection.PriceIsVisible && costlineOrSubsection.ShowsSectionUnit">
            ({{ (costlineOrSubsection.Units || 0) + ' ' + (costlineOrSubsection.UnitType || ((costlineOrSubsection.Units
            > 1) ? "Units" : "Unit") ) }})
          </ng-container>
        </i>
      </strong>
      <ng-container [ngTemplateOutlet]="clientVariableLine"
        [ngTemplateOutletContext]="{ vars: costlineOrSubsection.ClientVisibleVariables }"></ng-container>
    </td>
    <td class="table-cell line-item amount-cell">
      <ng-container *ngIf="showCheckbox && isUnselected && anySelected">
        <span class="optional-price"><small>{{ costlineOrSubsection.Total || 0 | formatNumber }} optional</small></span>
      </ng-container>
      <ng-container *ngIf="showCheckbox && !anySelected">
        <span><small>{{ costlineOrSubsection.Total || 0 | formatNumber }}</small></span>
      </ng-container>
    </td>
  </tr>

  <ng-container *ngIf="
      costlineOrSubsection.EstimateCostLineItems?.length
    ">
    <ng-container *ngFor="
        let costline of costlineOrSubsection.EstimateCostLineItems
      ">

      <ng-template [ngTemplateOutletContext]="{ costline,column:isAllQuantityViewAble ? undefined:3, isSubsectionChild: true, showCheckbox: showCheckbox, isSubsectionSelected: !isUnselected, anySelected: anySelected }"
        [ngTemplateOutlet]="sectionTemplateForPrint"></ng-template>
    </ng-container>
    <tr class="table-row" [ngClass]="{'unselected-option': isUnselected && anySelected, 'print-selection-item': showCheckbox, 'print-selection-selected': showCheckbox && !isUnselected, 'print-selection-child': showCheckbox, 'print-subsection-total': showCheckbox}" *ngIf="
        estimate?.IsItemized &&
        (!costlineOrSubsection.IsAssemblyOn || costlineOrSubsection.PriceIsVisible)
      ">
      <td [colSpan]="costlineOrSubsection.ShowsSectionUnit ? undefined : 3" class="table-cell line-item title t-right">
        <small>{{ costlineOrSubsection.Name }} Total</small>
      </td>

      <ng-container *ngIf="costlineOrSubsection.ShowsSectionUnit">
        <td class="table-cell line-item amount-cell">
          <small *ngIf="!isUnselected || !anySelected">{{ (costlineOrSubsection.Units) + ' ' +
            (costlineOrSubsection.UnitType || ((costlineOrSubsection.Units > 1) ? "Units" : "Unit") )
            }}</small>
        </td>
        <td class="table-cell line-item amount-cell">
          <small *ngIf="!isUnselected || !anySelected">{{
            (
            (costlineOrSubsection.Total || 0) /
            costlineOrSubsection.Units
            ) | formatNumber: {skipZerosAfterDecimal: true}
            }}</small>
        </td>
      </ng-container>

      <td class="table-cell line-item amount-cell">
        <small *ngIf="!isUnselected || !anySelected">{{
          costlineOrSubsection.Total || 0 | formatNumber
          }}</small>
        <span *ngIf="isUnselected && anySelected" class="optional-price"><small>{{
          costlineOrSubsection.Total || 0 | formatNumber
          }} optional</small></span>
      </td>
    </tr>
  </ng-container>
</ng-template>
<ng-template #sectionTemplate let-section="section" let-costline="costline" let-IsSelectionEnabled="IsSelectionEnabled"
  let-sectionId="sectionId" let-displayIndex="displayIndex" let-sectionIndex="sectionIndex"
  let-selectionType="selectionType">

  <!-- A selection's DIRECT child cost lines are the options the client picks between, so they
       ignore the per-line eye toggle — hiding one would leave an option that can be selected but
       never seen. Cost lines nested in a SUBSECTION are breakdown, not options, and still obey
       `IsViewable`. Mirrors ProjulV1Portal's estimate-description / print-previews. -->
  <div
    *ngIf="estimate?.IsItemized || IsSelectionEnabled || costline.IsViewable"
    class="cstm-grid-body-row item-selectable {{IsSelectionEnabled ? (selectionType == estimateSelectionType.OptionalMultipleSelection ? 'custom_checkbox' : 'custom_radio') : ''}}
    {{IsSelectionEnabled && status == estimateStatusTypes.Approved && !costline.IsSelectedForSelection? ' unselected-item-approved': ''}} {{status == estimateStatusTypes.Approved ? 'IsApproved': ''}}"
    [ngClass]="{'beforeSubsection-item': costline.beforesub && estimate?.IsItemized, 'beforeItem-subsection': costline.isPreviousSubsection && estimate?.IsItemized && !IsSelectionEnabled}">
    <ng-container
      *ngIf="IsSelectionEnabled && (status != estimateStatusTypes.Approved || (status == estimateStatusTypes.Approved && costline.IsSelectedForSelection))">
      <input *ngIf="selectionType == estimateSelectionType.OptionalMultipleSelection" type="checkbox"
        (change)="lineItemCheckbox($event, displayIndex, sectionIndex)" [(ngModel)]="costline.IsSelectedForSelection"
        id="checkbox-item-{{costline.Id}}" [disabled]="selectionsLocked">
      <input *ngIf="selectionType != estimateSelectionType.OptionalMultipleSelection" type="radio"
        id="radio-item-{{costline.Id}}" name="radio-grid-btn-{{sectionId}}"
        (change)="singleSelectOption($event, displayIndex, sectionIndex)"
        [checked]="costline.IsSelectedForSelection?true:null" [disabled]="selectionsLocked">
    </ng-container>

    <div class="cstm-grid-body-row-content isThisconternt">

      <ng-container *ngIf="IsSelectionEnabled">
        <div class="grid-row-content-left">
          <label *ngIf="selectionType == estimateSelectionType.OptionalMultipleSelection"
            for="checkbox-item-{{costline.Id}}"
            class="selectable-item{{status == estimateStatusTypes.Approved && !costline.IsSelectedForSelection ? '-approved': ''}}"></label>
          <label *ngIf="selectionType != estimateSelectionType.OptionalMultipleSelection"
            for="radio-item-{{costline.Id}}"
            class=" selectable-item{{status == estimateStatusTypes.Approved && !costline.IsSelectedForSelection ? '-approved': ''}}"></label>
        </div>
      </ng-container>

      <div class="grid-row-content-right">
        <div class="grid-row-content-right-inner main-contentt">

          <!-- description column -->
          <div class="grid-column grid-items-description">
            <div class="grid-items-description-inner f-grow">
              <div class="grid-items-description__left">
                <h5 class="mb-1 text-break">
                  <strong *ngIf="estimate?.IsItemized">
                    {{
                    costline.OnlyShowCategoryName
                    ? costline.Category?.Name
                    : costline.Name || costline.Props?.name || ""
                    }}
                  </strong>
                  <strong *ngIf="!estimate?.IsItemized">
                    {{
                    costline.OnlyShowCategoryName
                    ? costline.Category?.Name
                    : costline?.Name
                    }}
                    {{
                    (costline.OnlyShowCategoryName
                    ? costline.Category?.Name
                    : costline?.Name
                    )?.length && costline.QtyIsVisible
                    ? " (" +
                    costline.DefaultQty + ' ' +
                    (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" : "Unit")) +
                    ")"
                    : ""
                    }}
                  </strong>
                </h5>
                <p class="text-break font-12 innerHtmlCkEditorContent" [innerHtml]="costline.Description | sanitize"></p>
              </div>
              <div class="grid-items-description__right">
              </div>
            </div>
            <!-- images for section costlines -->
            <ng-container *ngIf="costline?.ItemsFiles?.length > 0">
              <div class="costline-images IsItemized">
                <div class="main-image" (click)="openImageInFullScreen(costline.ItemsFiles[0],costline.ItemsFiles)">
                  <img
                    [src]="photoThumbUrl | memoizedFn : costline.ItemsFiles[0] : $any(costline.ItemsFiles[0])?._thumbFailed"
                    (error)="onThumbError(costline.ItemsFiles[0])"
                    loading="lazy">
                </div>
                <div class="d-flex gap-1 mt-2">

                  <ng-container
                    *ngFor="let image of (costline.ItemsFiles.length > 5 ? (costline.ItemsFiles | slice:0:4) : costline.ItemsFiles); let first = first;let last = last">
                    <div class="image-items d-flex align-items-center" *ngIf="!first"
                      (click)="openImageInFullScreen(image,costline.ItemsFiles)">
                      <img [src]="photoThumbUrl | memoizedFn : image : $any(image)?._thumbFailed"
                        (error)="onThumbError(image)" loading="lazy">
                    </div>
                    <ng-container *ngIf="costline.ItemsFiles.length > 5">
                      <div class="image-items d-flex align-items-center justify-content-center more-count" *ngIf="last">
                        +{{ ((costline.ItemsFiles).length - 4) }}
                      </div>
                    </ng-container>
                  </ng-container>
                </div>


              </div>
            </ng-container>
            <!--End images for section costlines -->
          </div>

          <ng-container *ngIf="estimate?.IsItemized">
            <!-- quantity column -->
            <div class="grid-column quantity-col" *ngIf="
              (estimate?.IsItemized
                ? costline.QtyIsVisibleItemized
                : costline.QtyIsVisible)
            ">
              <span>
                {{ (costline.DefaultQty || 0) + ' ' + (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" :
                "Unit") ) }}
              </span>
            </div>
            <!-- cost column -->
            <div class="grid-column cost-col font-roboto" *ngIf="
              (estimate?.IsItemized
                ? costline.QtyIsVisibleItemized
                : costline.QtyIsVisible)
            ">
              <span>{{
                (costline.CalculatedRate || 0).toFixed(2) | formatNumber
                }}
              </span>
            </div>
          </ng-container>
          <!-- price column -->
          <div class="grid-column price-col font-roboto">
            <span>{{ costline.calculatedCustomerCost || 0 | formatNumber }}</span>
          </div>
        </div>

      </div>

    </div>
  </div>
</ng-template>
<ng-template #sectionTemplateSubsection let-costlineOrSubsection="costlineOrSubsection"
  let-IsSelectionEnabled="IsSelectionEnabled" let-sectionId="sectionId" let-displayIndex="displayIndex"
  let-sectionIndex="sectionIndex" let-selectionType="selectionType">
  <!-- Same rule as the direct-child cost lines above: a subsection sitting directly under a
       selection IS one of the options, so it ignores its own eye toggle. Its child cost lines
       are breakdown and still obey `IsViewable`. -->
  <div
    *ngIf="estimate?.IsItemized || IsSelectionEnabled || costlineOrSubsection.IsViewable"
    class="cstm-grid-body-row item-selectable {{IsSelectionEnabled ? (selectionType == estimateSelectionType.OptionalMultipleSelection ? 'custom_checkbox' : 'custom_radio') : ''}}
    {{IsSelectionEnabled && status == estimateStatusTypes.Approved && !costlineOrSubsection.IsSelectedForSelection? ' unselected-item-approved': ''}} {{status == estimateStatusTypes.Approved ? 'IsApproved': ''}}"
    [ngClass]="{'subsection-item-wrapper': !IsSelectionEnabled}">

    <ng-container
      *ngIf="IsSelectionEnabled && (status != estimateStatusTypes.Approved || (status == estimateStatusTypes.Approved && costlineOrSubsection.IsSelectedForSelection))">
      <input *ngIf="selectionType == estimateSelectionType.OptionalMultipleSelection" type="checkbox"
        (change)="lineItemCheckbox($event, displayIndex, sectionIndex)"
        [(ngModel)]="costlineOrSubsection.IsSelectedForSelection" id="checkbox-item-{{costlineOrSubsection.Id}}"
        [disabled]="selectionsLocked">
      <input *ngIf="selectionType != estimateSelectionType.OptionalMultipleSelection" type="radio"
        (change)="singleSelectOption($event, displayIndex, sectionIndex)"
        [checked]="costlineOrSubsection.IsSelectedForSelection?true:null" id="radio-item-{{costlineOrSubsection.Id}}"
        name="radio-grid-btn-{{sectionId}}" [disabled]="selectionsLocked">
    </ng-container>

    <div class="cstm-grid-body-row-content">

      <ng-container *ngIf="IsSelectionEnabled">
        <div class="grid-row-content-left">
          <label *ngIf="selectionType == estimateSelectionType.OptionalMultipleSelection"
            for="checkbox-item-{{costlineOrSubsection.Id}}"
            class=" selectable-item{{status == estimateStatusTypes.Approved && !costlineOrSubsection.IsSelectedForSelection ? '-approved': ''}}"></label>
          <label *ngIf="selectionType != estimateSelectionType.OptionalMultipleSelection"
            for="radio-item-{{costlineOrSubsection.Id}}"
            class="selectable-item{{status == estimateStatusTypes.Approved && !costlineOrSubsection.IsSelectedForSelection ? '-approved': ''}}"></label>
        </div>

      </ng-container>

      <div class="grid-row-content-right subsection-item" *ngIf="estimate?.IsItemized"
        [ngClass]="{'beforeSubsection-item':costlineOrSubsection.beforesub}">
        <div class="grid-row-content-right-inner">
          <div class="{{IsSelectionEnabled ? 'grid-column': 'grid-column-subsection'}} w-100">
            <p class="text-break" style="font-weight: 500;">
              {{ costlineOrSubsection.Name || "" }}
              <ng-container *ngIf="!costlineOrSubsection.PriceIsVisible && costlineOrSubsection.ShowsSectionUnit">
                ({{ (costlineOrSubsection.Units || 0) + ' ' + (costlineOrSubsection.UnitType ||
                ((costlineOrSubsection.Units > 1) ? "Units" : "Unit") ) }})
              </ng-container>
            </p>
            <ng-container [ngTemplateOutlet]="clientVariableLine"
              [ngTemplateOutletContext]="{ vars: costlineOrSubsection.ClientVisibleVariables }"></ng-container>
          </div>
        </div>
        <ng-container *ngIf="costlineOrSubsection.EstimateCostLineItems?.length">
          <div [class]="!IsSelectionEnabled? 'sub-section-item-round margin-b-2':'margin-b-2'">
            <ng-container *ngFor="let costline of costlineOrSubsection.EstimateCostLineItems; let first = first">
              <div *ngIf="estimate?.IsItemized || costline.IsViewable" class="grid-row-content-right-inner" [ngClass]="{'first-subItem': first}">

                <!-- description column -->
                <div class="grid-column grid-items-description">
                  <div class="grid-items-description-inner f-grow">
                    <div class="grid-items-description__left">
                      <h5 class="mb-1 text-break">
                        <strong>{{
                          costline.OnlyShowCategoryName
                          ? costline.Category?.Name
                          : costline.Name || costline.Props?.name || ""
                          }}</strong>
                      </h5>
                      <p class="text-break font-12 innerHtmlCkEditorContent" [innerHtml]="costline.Description | sanitize"></p>
                    </div>

                    <div class="grid-items-description__right">
                    </div>
                  </div>
                  <!-- images for itemized subsection -->
                  <ng-container *ngIf="costline?.ItemsFiles?.length > 0">
                    <div class="costline-images">
                      <div class="main-image"
                        (click)="openImageInFullScreen(costline.ItemsFiles[0],costline.ItemsFiles)">
                        <img
                          [src]="photoThumbUrl | memoizedFn : costline.ItemsFiles[0] : $any(costline.ItemsFiles[0])?._thumbFailed"
                          (error)="onThumbError(costline.ItemsFiles[0])"
                          loading="lazy">
                      </div>
                      <div class="d-flex gap-1 mt-2">
                        <ng-container
                          *ngFor="let images of (costline.ItemsFiles.length > 5 ? (costline.ItemsFiles | slice:0:4) : costline.ItemsFiles); let first = first;let last = last">
                          <div class="image-items d-flex align-items-center" *ngIf="!first"
                            (click)="openImageInFullScreen(images,costline.ItemsFiles)">
                            <img [src]="photoThumbUrl | memoizedFn : images : $any(images)?._thumbFailed"
                              (error)="onThumbError(images)" loading="lazy">
                          </div>
                          <ng-container *ngIf="costline.ItemsFiles.length > 5">
                            <div class="image-items d-flex align-items-center justify-content-center more-count"
                              *ngIf="last">
                              +{{ ((costline.ItemsFiles).length - 4) }}
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>


                    </div>
                  </ng-container>
                  <!--End images for itemized subsection -->
                </div>

                <!-- quantity column -->
                <div class="grid-column quantity-col" *ngIf="
                (estimate?.IsItemized
                  ? costline.QtyIsVisibleItemized
                  : costline.QtyIsVisible)
              ">
                  <span>
                    {{ (costline.DefaultQty || 0) + ' ' + (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" :
                    "Unit") ) }}
                  </span>
                </div>
                <!-- cost column -->
                <div class="grid-column cost-col font-roboto" *ngIf="
                (estimate?.IsItemized
                  ? costline.QtyIsVisibleItemized
                  : costline.QtyIsVisible)
              ">
                  <span>{{
                    (costline.CalculatedRate || 0).toFixed(2) | formatNumber
                    }}
                  </span>
                </div>
                <!-- price column -->
                <div class="grid-column price-col font-roboto">
                  <span>{{ costline.calculatedCustomerCost || 0 | formatNumber }}</span>
                </div>

              </div>
            </ng-container>
          </div>


          <div class="grid-row-content-right-inner" *ngIf="estimate?.IsItemized && (!costlineOrSubsection.IsAssemblyOn || costlineOrSubsection.PriceIsVisible)">
            <div class="grid-column w-100 min-width-0" [ngClass]="{'bg-transparent':!IsSelectionEnabled}">
              <p class="grid-subsection-total-label-parent">
                <span class="grid-subsection-total-label-name">{{ costlineOrSubsection.Name || "" }}</span> Total
              </p>
            </div>

            <ng-container *ngIf="costlineOrSubsection.ShowsSectionUnit">
              <!-- footer quantity column -->
              <div class="grid-column quantity-col">
                <span>{{ (costlineOrSubsection.Units || 0) + ' ' + (costlineOrSubsection.UnitType ||
                  ((costlineOrSubsection.Units > 1) ? "Units" : "Unit") )}}
                </span>
              </div>
              <!-- footer cost column -->
              <div class="grid-column cost-col font-roboto">
                <span>
                  {{
                  (
                  costlineOrSubsection.Units > 0 && costlineOrSubsection.Total > 0 ?
                  ((costlineOrSubsection.Total) /
                  (costlineOrSubsection.Units)) : 0
                  ) | formatNumber: {skipZerosAfterDecimal: true}
                  }}
                </span>
              </div>
            </ng-container>
            <!-- footer price column -->
            <div class="grid-column price-col font-roboto">
              <span>{{costlineOrSubsection.Total || 0 | formatNumber}}</span>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="grid-row-content-right subsection-item non-itemized-subsection" *ngIf="!estimate?.IsItemized">
        <div class="grid-row-content-right-inner mb-0">

          <!-- description column -->
          <div class="d-flex grid-column f-grow">
            <div class="grid-items-description f-column f-grow">
              <div class="{{IsSelectionEnabled ? 'grid-column': 'grid-column-subsection'}} w-100">
                <p class="text-break" style="font-weight: 500; font-size: 12px;">
                  <strong>{{ costlineOrSubsection.Name || "" }}</strong>
                  <i>
                    <small>
                      {{
                      costlineOrSubsection.ShowsSectionUnit
                      ? (costlineOrSubsection.Units || 0) +
                      " " +
                      (costlineOrSubsection.UnitType || ((costlineOrSubsection.Units > 1) ? "Units" : "Unit"))
                      : ""
                      }}
                      {{
                      costlineOrSubsection.ShowsSectionUnit &&
                      costlineOrSubsection.PriceIsVisible
                      ? " x " +
                      ((
                      costlineOrSubsection.Units > 0 && costlineOrSubsection.Total > 0 ?
                      ((costlineOrSubsection.Total) /
                      (costlineOrSubsection.Units)) : 0
                      ) | formatNumber: {skipZerosAfterDecimal: true})
                      : ""
                      }}
                    </small>
                  </i>
                </p>
                <ng-container [ngTemplateOutlet]="clientVariableLine"
                  [ngTemplateOutletContext]="{ vars: costlineOrSubsection.ClientVisibleVariables }"></ng-container>
              </div>
              <ng-container *ngFor="let costline of costlineOrSubsection.EstimateCostLineItems; let first = first">
                <div class="grid-items-description-inner px-2 "
                  *ngIf="(IsSelectionEnabled && costline.IsViewable) || !IsSelectionEnabled">
                  <div class="grid-items-description__left">
                    <h4 class="mb-1 text-break">
                      {{
                      costline.OnlyShowCategoryName
                      ? costline.Category?.Name
                      : costline?.Name
                      }}
                      {{
                      (costline.OnlyShowCategoryName
                      ? costline.Category?.Name
                      : costline?.Name
                      )?.length && costline.QtyIsVisible
                      ? " (" +
                      costline.DefaultQty + ' ' +
                      (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" : "Unit")) +
                      ")"
                      : ""
                      }}
                    </h4>
                    <p class="text-break font-12 innerHtmlCkEditorContent" [innerHtml]="costline.Description | sanitize"></p>
                  </div>
                  <div class="grid-items-description__right">
                  </div>
                </div>
              </ng-container>
            </div>

            <!-- images for non-itemized subsection -->
            <ng-container *ngIf="costlineOrSubsection?.ItemsFiles?.length > 0">
              <div class="costline-images">
                <div class="main-image"
                  (click)="openImageInFullScreen(costlineOrSubsection.ItemsFiles[0],costlineOrSubsection.ItemsFiles)">
                  <img
                    [src]="photoThumbUrl | memoizedFn : costlineOrSubsection.ItemsFiles[0] : $any(costlineOrSubsection.ItemsFiles[0])?._thumbFailed"
                    (error)="onThumbError(costlineOrSubsection.ItemsFiles[0])"
                    loading="lazy" alt="151515">
                </div>
                <div class="d-flex gap-1 mt-2">
                  <ng-container
                    *ngFor="let images of (costlineOrSubsection.ItemsFiles.length > 5 ? (costlineOrSubsection.ItemsFiles | slice:0:4) : costlineOrSubsection.ItemsFiles); let first = first;let last = last">
                    <div class="image-items d-flex align-items-center" *ngIf="!first"
                      (click)="openImageInFullScreen(images,costlineOrSubsection.ItemsFiles)">
                      <img [src]="photoThumbUrl | memoizedFn : images : $any(images)?._thumbFailed"
                        (error)="onThumbError(images)" loading="lazy">
                    </div>
                    <ng-container *ngIf="costlineOrSubsection.ItemsFiles.length > 5">
                      <div class="image-items d-flex align-items-center justify-content-center more-count"
                        *ngIf="last">
                        +{{ ((costlineOrSubsection.ItemsFiles).length - 4) }}
                      </div>
                    </ng-container>
                  </ng-container>
                </div>


              </div>
            </ng-container>
            <!--End images for non-itemized subsection -->
          </div>

          <!-- price column -->
          <div class="grid-column price-col font-roboto">
            <span>{{ costlineOrSubsection.Total || 0 | formatNumber }}</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- This template will only use for print preview -->
<ng-template #sectionTemplateForPrint let-costline="costline" let-column="column" let-showCheckbox="showCheckbox" let-isUnselected="isUnselected" let-anySelected="anySelected" let-isSubsectionChild="isSubsectionChild" let-isSubsectionSelected="isSubsectionSelected">
  <ng-container *ngIf="estimate?.IsItemized || costline.IsViewable">
    <tr class="table-row" [ngClass]="{'unselected-option': (isUnselected && anySelected && !isSubsectionChild) || (isSubsectionChild && !isSubsectionSelected && anySelected), 'print-selection-item': showCheckbox || isSubsectionChild, 'print-selection-selected': (showCheckbox && !isUnselected && !isSubsectionChild) || (isSubsectionChild && isSubsectionSelected), 'print-selection-child': isSubsectionChild}">
      <td [colSpan]="column" class="table-cell line-item">
        <span *ngIf="showCheckbox && !isSubsectionChild" class="selection-checkbox">{{ isUnselected ? '☐' : '☑' }}</span>
        <h4>{{
          costline.OnlyShowCategoryName
          ? costline.Category?.Name
          : costline.Name || costline.Props?.name || ""
          }}</h4>
        <p class="font-12 innerHtmlCkEditorContent" [innerHtml]="costline.Description | sanitize"></p>
        <div class="non-itemized-images-print">
          <ng-container *ngFor="let image of costline.ItemsFiles">
            <div class="image-items d-flex align-items-center Medium">
              <img [src]="photoThumbUrl | memoizedFn : image : $any(image)?._thumbFailed"
                (error)="onThumbError(image)" loading="lazy">
            </div>
          </ng-container>
        </div>
      </td>

      <td class="table-cell line-item amount-cell" *ngIf="
          !(estimate?.IsItemized
            ? costline.QtyIsVisibleItemized
            : costline.QtyIsVisible) && isAllQuantityViewAble
        "></td>

      <td class="table-cell line-item amount-cell" *ngIf="
          (estimate?.IsItemized
            ? costline.QtyIsVisibleItemized
            : costline.QtyIsVisible) && isAllQuantityViewAble
        ">
        <small *ngIf="!isUnselected || !anySelected || isSubsectionChild">
          {{ (costline.DefaultQty || 0) + ' ' + (costline.UnitType || ((costline.DefaultQty > 1) ? "Units" : "Unit") )
          }}
        </small>
      </td>

      <td class="table-cell line-item amount-cell" *ngIf="
          !(estimate?.IsItemized
            ? costline.QtyIsVisibleItemized
            : costline.QtyIsVisible) && isAllQuantityViewAble
        "></td>

      <td class="table-cell line-item amount-cell" *ngIf="
          (estimate?.IsItemized
            ? costline.QtyIsVisibleItemized
            : costline.QtyIsVisible) && isAllQuantityViewAble
        ">
        <small *ngIf="!isUnselected || !anySelected || isSubsectionChild">
          {{
            (costline.CalculatedRate || 0).toFixed(2) | formatNumber
          }}
        </small>
      </td>

      <td class="table-cell line-item amount-cell">
        <small *ngIf="!isUnselected || !anySelected || isSubsectionChild">
          {{ costline.calculatedCustomerCost || 0 | formatNumber }}
        </small>
        <span *ngIf="isUnselected && anySelected && !isSubsectionChild" class="optional-price"><small>{{ costline.calculatedCustomerCost || 0 | formatNumber }} optional</small></span>
      </td>
    </tr>
  </ng-container>
</ng-template>
<ng-template #removedItemsForPrint let-colspan="colspan">
  <tr class="table-row" tabindex="1" *ngIf="removedSections?.length">
    <td class="table-cell line-item title"></td>
  </tr>
  <ng-container *ngFor="let item of removedSections">
    <tr class="table-row total-row" >
      <td class="table-cell f-100" [colSpan]="colspan">
        <div class="grid-items-description__left">
          <h5 class="text-break" style="font-size: 14px;">{{ item.Name || "Product or Service" }}</h5>
          Removed from previous
          <strong>{{
            item.ModifiedFromSectionDetailsType ===
            estimateDetailTypeEnum.Normal
            ? "Estimate"
            : "Change Order"
            }}
            :
          </strong>
          <strong style="
              width: 400px;
              max-width: 60vw;
              vertical-align: top;
            ">{{ item.ModifiedFromSectionDetailsNumber }}</strong>
        </div>
      </td>
      <td class="table-cell amount-cell variable">
        <div class="grid-column price-col font-roboto">
          <span>{{ item.Total || 0 | formatNumber }}</span>
        </div>
      </td>
    </tr>
    <tr class="table-row" tabindex="1" *ngIf="removedSections?.length">
      <td class="table-cell line-item title print-nopd-tr"></td>
    </tr>
  </ng-container>
  <tr class="table-row" tabindex="1" *ngIf="removedSections?.length">
    <td class="table-cell line-item title"></td>
  </tr>
</ng-template>

<!-- The client-visible variables under an estimate, section or subsection name: one template for every
     layout so screen and print agree. `&ngsp;` is a real space; preserveWhitespaces is off. -->
<ng-template #clientVariableLine let-vars="vars">
  <p *ngIf="vars?.length" class="cvars text-muted font-12 mb-0">
    <span class="pair" *ngFor="let clientVariable of vars"><span class="nm">{{ clientVariable.Name }}</span>&ngsp;<span class="vl font-roboto">{{ clientVariable.Value }}</span></span>
  </p>
</ng-template>
